import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'
import './index.css';
import 'file-saver';
import 'tv4';
import Plot from 'react-plotly.js';
import jexcel from 'jexcel';
//import Chart from "react-google-charts";

import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css';

import Structure  from './structure.js';
import Wellgeo    from './wellgeo.js';
import Units      from './units.js';
import Build      from './build.js';
import dependency from './dependency.png'
import './jexcel.css';

const global  = require('./global.js');
const plotter = require('./plot.js');

var m_server    = '';
var m_remoteserver = m_server;
var m_devcmd    = '';
var m_awslambda = false;
var m_months    = ["JAN","FEB","MAR","APR","MAY","JUN","JLY","AUG","SEP","OCT","NOV","DEC"];
var m_debug     = false;
var m_perfflow  = true;
var m_dunits    = false;
var m_compopt   = false;
var m_rkscomp   = false;
var m_user      = 'none';
var m_d3        = false;
var m_svn       = 37043;
var m_unit      = 0;
var m_uitype    = 'alun';
var m_testaws   = false;

global.common.server  = m_server;
global.common.months  = m_months;
global.common.user    = m_user;
global.common.unitset = m_unit;

//
// Actually modify the model data
//
function Submit(paravalues,parasensitivity,data,index,name,revision)
{
  var count=0;
  var scount=0;

  for ( var i=0; i<paravalues.length; i++ )
  {
    if ( paravalues[i]!==null  && index<data.length )
    {
      if ( data[index].para[i].value!==paravalues[i] )
      {
        data[index].para[i].value = paravalues[i];
        paravalues[i] = null;
        count++;
      }
    }
    if ( parasensitivity[i]!==0 && index<data.length )
    {
      if ( data[index].para[i].sensitive!==parasensitivity[i] )
      {
        data[index].para[i].sensitive = parasensitivity[i];
        parasensitivity[i]=0;
        scount++;
      }
    }
  }

  if ( count>0 || scount>0 ) revision.rev++;

  if ( m_debug ) global.alertx(' Prog:submitdata '+count+' changes '+scount+' sensitivity changes',false);
}

function Submitsens(paravalues,data,index,sensselected)
{
  for ( var i=0; i<paravalues.length; i++ )
  {
    if ( paravalues[i]!==null  && index<data.length )
    {
      if ( data[index].para[i].value!==paravalues[i] )
      {
        data[index].para[i].value[sensselected] = paravalues[i];
        paravalues[i] = null;
      }
    }
  }
}

//
// Convert tooltips/default/data depending on the unit set
//
function convert(unitnum)
{
  var u = new Units();

  for ( var sect in STRUCTURE.sections )
  {
    for ( var isixc=0; isixc<STRUCTURE.sections[sect].sixcs.length; isixc++ )
    {
      for ( var ip=0; ip<STRUCTURE.sections[sect].sixcs[isixc].paras.length; ip++ )
      {
        var tip = '';
        var unit = '';
        if ( typeof STRUCTURE.sections[sect].sixcs[isixc].paras[ip].tip !== 'undefined' ) tip = STRUCTURE.sections[sect].sixcs[isixc].paras[ip].tip;
        if ( typeof STRUCTURE.sections[sect].sixcs[isixc].paras[ip].unit !== 'undefined' &&
                    STRUCTURE.sections[sect].sixcs[isixc].paras[ip].unit !== '' )
        {
          var utype = STRUCTURE.sections[sect].sixcs[isixc].paras[ip].unit;
          unit  = u.units[utype][unitnum];
          if ( unit!=='' ) unit = ', '+unit;

          if ( unitnum!==m_unit )
          {
            STRUCTURE.sections[sect].sixcs[isixc].paras[ip].value *= unitconversion(utype,m_unit,unitnum);
          }
        }
        STRUCTURE.sections[sect].sixcs[isixc].paras[ip].utip = tip+unit;
      }

      var data = DATA[sect];
      var sixc = STRUCTURE.sections[sect].sixcs[isixc].name;
      for ( var i=0; i<data.length; i++ )
      {
        for ( var j=0; j<data[i].data[sixc].length; j++ )
        {
          for ( ip=0; ip<STRUCTURE.sections[sect].sixcs[isixc].paras.length; ip++ )
          {
            unit = '';
            if ( typeof STRUCTURE.sections[sect].sixcs[isixc].paras[ip].unit !== 'undefined' &&
                        STRUCTURE.sections[sect].sixcs[isixc].paras[ip].unit !== '' )
            {
              utype = STRUCTURE.sections[sect].sixcs[isixc].paras[ip].unit;
              if ( unitnum!==m_unit && Number.isFinite(data[i].data[sixc][j].para[ip].value) )
              {
                data[i].data[sixc][j].para[ip].value *= unitconversion(utype,m_unit,unitnum);
              }
            }
          }
        }
      }
    }
    if ( sect==='build' )
    {
      data = DATA[sect];
      for ( i=0; i<data.length; i++ )
      {
        var constants = data[i].data['constants'];
        for ( var key in constants )
        {
          constants[key].value *= unitconversion(constants[key].unit,m_unit,unitnum);
        }
      }
    }
  }

  convertpvt(unitnum);

  m_unit = unitnum;
  global.common.unitset = m_unit;
}

function convertpvt(unitnum)
{
  for ( var i=0; i<1; i++ ) // Only convert the default (at least for now)
  {
    var fluid = DATA[SIXXCS['fluid'].sect][i].data.fluid[0].data;
    for ( const key in fluid )
    {
      if ( key==="DENSITY" )
      {
        var den = fluid[key][0];
        den.oil   *= unitconversion('density',m_unit,unitnum);
        den.water *= unitconversion('density',m_unit,unitnum);
        den.gas   *= unitconversion('density',m_unit,unitnum);
      }
      else if ( key==="PVTW" )
      {
        var wat = fluid[key][0];
        wat.pref *= unitconversion('pressure',m_unit,unitnum);
        wat.co   *= unitconversion('compressibility',m_unit,unitnum);
        wat.cov  *= unitconversion('compressibility',m_unit,unitnum);
      }
      else if ( key==="PVCO" )
      {
        var pvco = fluid[key][0];
        pvco.psat *= unitconversion('pressure',m_unit,unitnum);
        pvco.rs   *= unitconversion('rs',m_unit,unitnum);
        pvco.bo   *= unitconversion('fvf',m_unit,unitnum);
        pvco.co   *= unitconversion('compressibility',m_unit,unitnum);
        pvco.cv   *= unitconversion('compressibility',m_unit,unitnum);
      }
      else if ( key==="PVDG" )
      {
        pvco = fluid[key][0];
        pvco.pres *= unitconversion('pressure',m_unit,unitnum);
        pvco.bg   *= unitconversion('fvfg',m_unit,unitnum);
      }
      else if ( key==="PVTO" )
      {
        for ( i=0; i<fluid[key][0].length; i++ )
        {
          var rec = fluid[key][0][i];
          rec.rs *= unitconversion('rs',m_unit,unitnum);
          for ( var j=0; j<rec.vl.length; j++ )
          {
            rec.vl[j].psat *= unitconversion('pressure',m_unit,unitnum);
            rec.vl[j].bo   *= unitconversion('fvf',m_unit,unitnum);
          }
        }
      }
      else if ( key==="PVTG" )
      {
        for ( i=0; i<fluid[key][0].length; i++ )
        {
          rec = fluid[key][0][i];
          rec.psat *= unitconversion('pressure',m_unit,unitnum);
          for ( j=0; j<rec.vl.length; j++ )
          {
            rec.vl[j].rv *= unitconversion('rv',m_unit,unitnum);
            rec.vl[j].bg *= unitconversion('fvfg',m_unit,unitnum);
          }
        }
      }
    }
  }
}


//
// Convert unit set
//
function unitconversion(utype,uold,unew)
{
  var fact=1.0;

  var u = new Units();

  if ( uold===0 && unew===1 ) fact = u.conv[utype][0];
  if ( uold===0 && unew===2 ) fact = u.conv[utype][1];
  if ( uold===1 && unew===0 ) fact = 1.0/u.conv[utype][0];
  if ( uold===2 && unew===0 ) fact = 1.0/u.conv[utype][1];
  if ( uold===1 && unew===2 ) fact = u.conv[utype][1]/u.conv[utype][0];
  if ( uold===2 && unew===1 ) fact = u.conv[utype][0]/u.conv[utype][1];

  return fact;
}

//
// Initiate completions mode
//
function completionsmode(qcomp)
{
  var constants = DATA['build'][0].data['constants'];

  if ( qcomp )
  {
    m_perfflow = false;
    global.common.perfflow = m_perfflow;

    SIXXCS['well'].paras[1].value = 100; // shorter well
    SIXXCS['well'].paras[5].value = 0;   // vertical

    for ( var i=0; i<STRUCTURE.sections[SIXXCS['frac'].sect].sixcn.length; i++ )
    {
      if ( STRUCTURE.sections[SIXXCS['frac'].sect].sixcn[i]==='frac' )
      {
        STRUCTURE.sections[SIXXCS['frac'].sect].sixcn[i] = 'completion';
        STRUCTURE.sections[SIXXCS['frac'].sect].sixcs[i] = SIXXCS['completion'];
        STRUCTURE.sections[SIXXCS['frac'].sect].sixcs[i].name = 'completion';
        SIXXCS['completion'].sect = SIXXCS['frac'].sect;
      }
    }

    SIXXCS['poroperm'].paras.push({ name: 'ffrac',value: 2, comp:'', unit: 'none', tip: 'Fracture fraction '  });

    SIXXCS['poroperm'].paras[1].value = 10;    // reasonable permeability
    SIXXCS['poroperm'].paras[2].value = 0.05;  // some fraction
    constants.sigma.value = 0.12;

    SIXXCS['schedule'].paras[1] = { name: 'completion',value: 'comp1', comp:'completion', tip: 'pointer to completion'  }

    var status = { name: 'status',value: 'open', comp:'', unit: '', tip: 'open or closed' };
    SIXXCS['schedule'].paras.push(status);

    SIXXCS['production'].paras.push({ name: 'init rate',value: '', comp:'', unit: 'surface_volume_rate', tip: 'initial flow rate, overrides the BHP value to match this oil rate' });

    //
    // Initial data
    //
    DATA[SIXXCS['poroperm'].sect][0].data['poroperm'][0].para.push({ value: 0.05, sensitivity: false });

    var fracs  = SIXXCS['completion'].paras;

    // Comp --------------------------------------------------
    var comp = [];
    for ( var j=0; j<fracs.length; j++ )
    {
      comp.push({ value: SIXXCS['completion'].paras[j].value, sensitivity: false });
    }
    var newcomp={ name:'comp1', type: 'simple', para: comp };
    DATA[SIXXCS['completion'].sect][0].data['completion'].push(newcomp);

    DATA[SIXXCS['schedule'].sect][0].data['schedule'][0].para[1].value = 'comp1';
    DATA[SIXXCS['schedule'].sect][0].data['schedule'][0].para.push({ value: 'open', sensitivity: false });

  }
  else if ( typeof SIXXCS['completion'].sect==='undefined' ) { }
  else
  {
    m_perfflow = true;
    global.common.perfflow = m_perfflow;

    SIXXCS['well'].paras[1].value = 10000; // long
    SIXXCS['well'].paras[5].value = 90;    // horizontal

    for ( i=0; i<STRUCTURE.sections[SIXXCS['completion'].sect].sixcn.length; i++ )
    {
      if ( STRUCTURE.sections[SIXXCS['completion'].sect].sixcn[i]==='completion' )
      {
        STRUCTURE.sections[SIXXCS['completion'].sect].sixcn[i] = 'frac';
        STRUCTURE.sections[SIXXCS['completion'].sect].sixcs[i] = SIXXCS['frac'];
        STRUCTURE.sections[SIXXCS['completion'].sect].sixcs[i].name = 'frac';
      }
    }

    SIXXCS['poroperm'].paras.splice(2,1);

    SIXXCS['poroperm'].paras[1].value = 0.000001;
    constants.sigma.value = 0.000001;

    SIXXCS['schedule'].paras[1].name = 'frac';
    SIXXCS['schedule'].paras[2].tip  = 'pointer to stages';

    SIXXCS['schedule'].paras.splice(4,1);;
  }

  convert(m_unit);
}

function copyobj(objin) // as it says
{
  var serial = JSON.stringify(objin);
  return JSON.parse(serial);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// Start for real....
//////////////////////////////////////////////////////////////////////////////////////////////////////////

class Sixxcs extends React.Component
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props);
  }
  render()
  {
    const sixcs = this.props.sixcs;
    const sel = this.props.selected;
    const listxcs2=sixcs.map( function(obj,index)
    {
      var x;
      var y;
      var tip = '';
      if ( typeof obj.skip!=='undefined' )
      {
        x=<td key={index}></td>;
        y=<td key={index}></td>;
      }
      else if ( typeof obj.tip!=='undefined' )
      {
        tip=obj.tip;

        x=<td key={index}><div className="proplinkx" data-tooltip-id="blue" data-tooltip-content={tip}> <button key={index} onClick={() => this.props.onClick(index)} ><u>{obj.name}</u>  </button>  </div></td>;
        y=<td key={index}><div className="proplinky" data-tooltip-id="blue" data-tooltip-content={tip}> <button key={index} ><i><b><u>{obj.name}</u></b></i></button></div></td>;
      }
      else
      {
        x = <td key={index}><div className="proplinkx" data-tooltip-id="blue" data-tooltip-content={tip} > <button key={index}  onClick={() => this.props.onClick(index) } ><u>{obj.name}</u>  </button>  </div></td>;
        y = <td key={index}><div className="proplinky" data-tooltip-id="blue" data-tooltip-content={tip} > <button key={index} ><i><b><u>{obj.name}</u></b></i></button></div></td>;
      }

      if ( sel===index ) return y;
      else               return x;
    }, this );

    return (

       <>{listxcs2}</>

    );
  }

}

class Middle extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state = { showlogs: false, showdip: false, dip: { refx: -1234, refy: -1234, dip: -1234, orient: -1234 },
                   showstress: false, stresssol: { Poisson: -1234, Young: -1234, Biot: -1234, extent: -1234, apply: -1234 } };
    this.inputRef = React.createRef();
  }
  render()
  {
    var global = this.props.sixxc==='formation' || this.props.sixxc==='fluid' || this.props.sixxc==='stress' ;
    var jsonim = this.props.sixxc==='well' || this.props.sixxc==='fluid';
    var qdip   = this.props.sixxc==='formation';
    var qgeom  = this.props.sixxc==='geomech';
    var form   = false;
    var top    = 0.0;
    var whereiswell      = SIXXCS['well'].sect;
    var whereislayer     = SIXXCS['layer'].sect;
    var whereisrock      = SIXXCS['rock'].sect;
    var whereisporoperm  = SIXXCS['poroperm'].sect;
  	var whereisformation = SIXXCS['formation'].sect;
    var wsel = 0; if ( typeof this.props.fileselected[whereiswell]!=='undefined'      ) wsel=this.props.fileselected[whereiswell];
    var lsel = 0; if ( typeof this.props.fileselected[whereislayer]!=='undefined'     ) lsel=this.props.fileselected[whereislayer];
    var rsel = 0; if ( typeof this.props.fileselected[whereisrock]!=='undefined'      ) rsel=this.props.fileselected[whereisrock];
    var psel = 0; if ( typeof this.props.fileselected[whereisporoperm]!=='undefined'  ) psel=this.props.fileselected[whereisporoperm];
  	var fsel = 0; if ( typeof this.props.fileselected[whereisformation]!=='undefined' ) fsel=this.props.fileselected[whereisformation];
    if ( this.props.sixxc==='well' ) // multi-well cases
    {
      if ( DATA[whereiswell][wsel].data.well.length>1 ) form =true;
      top = DATA[whereisformation][fsel].data.formation[0].para[0].value;
    }

    var extra =  <tr><td>&nbsp;</td></tr>;
    var tip = 'import pvt, honouring the pvt schema';
    if ( this.props.sixxc==='well' ) tip = 'import a jsonwell - honouring the 6X well schema';
    if ( jsonim ) extra = <tr><td className="errorbox"><span className="adddel" data-tooltip-id="blue" data-tooltip-content={tip} onClick={(i) => this.import(i)}><u>imp</u>
                             </span>
                            </td></tr>;
    if ( qgeom ) extra = <tr><td></td><td></td><td className="errorbox"><span className="adddel"  onClick={(i) => this.showstress(i)}><u>stress</u>
                             </span>
                            </td></tr>;


    var dip = [];
    for ( var key in this.state.dip )
    {
      dip.push(key);
    }
    var dipr = <></>;
    if ( typeof DATA['Reservoirs'][fsel].data.dip!=='undefined') dipr = dip.map((name,index) => this.renderdip(SIXXCS['dip'],index,name,this.state.dip[name],DATA['Reservoirs'][fsel].data.dip[0].para) );

    var igeom=0; if ( typeof(this.props.nameindex[this.props.sixxc])!=='undefined') igeom = this.props.nameindex[this.props.sixxc];
    var stress = [];
    for ( key in this.state.stresssol )
    {
      stress.push(key);
    }
    var stressr = <></>;
    if ( qgeom && typeof DATA['Reservoirs'][fsel].data.stresssol!=='undefined') stressr = stress.map((name,index) => this.renderstress(SIXXCS['stresssol'],index,name,this.state.stresssol[name],DATA['Reservoirs'][fsel].data.stresssol[igeom].para) );

    return (
          <div>
          <table><tbody><tr><td>Name</td></tr>
          <tr><td><Names names={this.props.listnames} nameindex={this.props.findex} sixxc={this.props.sixxc}
                         types={this.props.listtypes} class={'names'}
                         handleChange={(i) => this.props.handleChange(i)} /></td><td>
              <table><tbody><tr>

            {global? <>
                  {qdip? <td className="errorbox"><span className="adddel" onClick={() => this.showdip()}><u>dip</u></span></td> :
                  <td></td>}</>:
              <><td className="errorbox"><span className="adddel" onClick={(i) => this.props.add(i)}><u>add</u></span></td>
                <td className="errorbox"><span className="adddel" onClick={(i) => this.props.deleteitem(i)}><u>del</u></span></td>
                <td className="errorbox"><span className="adddel" onClick={(i) => this.props.rename(i)}><u>ren</u></span></td>
                { form ? <td className="errorbox"><span className="adddel" onClick={(i) => this.logs(i)}><u>logs</u></span></td> : <td></td> }
                  </> }
              <td></td>
              <td><Types/></td></tr>
            { extra }
                <tr><td>&nbsp;</td></tr>
            </tbody></table>
            </td></tr></tbody></table>
            <div className="hidden" > <input type={'file'} ref={this.inputRef} value={''} onChange={(e) => this.props.importfile(e)} ></input> </div>
            <ReactModal isOpen={this.state.showlogs} appElement={document.getElementById('root')}  >
              <div>
                  <Geosheet top={top}
                            wells={DATA[whereiswell][wsel].data.well}
                            layers={DATA[whereislayer][lsel].data.layer}
                            rock={DATA[whereisrock][rsel].data.rock}
                            poroperm={DATA[whereisporoperm][psel].data.rock}
                            formation={DATA[whereisformation][fsel].data.formation}
                            tomain={() => this.closelogs()} />
              </div>
            </ReactModal>
             <ReactModal
                 isOpen={this.state.showdip}
                 appElement={document.getElementById('root')}
                 className="Dip"  >
              <div style={{ background: this.props.colour }} >
                <table><tbody><tr><td>Formation dip</td><td></td><td></td><td>&nbsp;&nbsp;</td><td><span onClick={() => this.closedip(DATA['Reservoirs'][fsel].data.dip[0].para,false)} >&times;</span></td></tr>
                {dipr}
                <tr><td>&nbsp;</td></tr>
                    <tr><td></td><td><button onClick={() => this.closedip(DATA['Reservoirs'][fsel].data.dip[0].para,true) } style={{ width: '80px' }} >ok</button></td></tr>
                <tr><td>&nbsp;</td></tr>
                </tbody></table>
              </div>
              </ReactModal>
             <ReactModal
                 isOpen={this.state.showstress}
                 appElement={document.getElementById('root')}
                 className="StressSol"  >
              <div style={{ background: this.props.colour }} >
                <table><tbody><tr><td>
                <table><tbody><tr><td>Stress Solver</td><td></td><td></td><td>&nbsp;&nbsp;</td><td><span onClick={() => this.closestress(DATA['Reservoirs'][fsel].data.stresssol[0].para,false,fsel)} >&times;</span></td></tr>
                {stressr}
                <tr><td>&nbsp;</td></tr></tbody></table>

                <table><tbody>
                <tr><td>Note, that applying the stress solution envokes a different model of fracturing behaviour.
                When pressure is used as a proxy for stress, the minimum stress (input on the Stress tab) is the fracturing pressure.
                With the stress solution active it's the prevaling stress state, with the fracturing pressure being somewhat higher due to
                the increased stress.
                </td></tr>
                <tr><td>&nbsp;</td></tr>
                    <tr><td><button onClick={() => this.closestress(DATA['Reservoirs'][fsel].data.stresssol[igeom].para,true,fsel) } style={{ width: '80px' }} >ok</button></td></tr>
                <tr><td>&nbsp;</td></tr>
                </tbody></table>
                </td></tr></tbody></table>
              </div>
              </ReactModal>
          </div>
    );
  }

  renderdip(dip,i,name,v,vold)
  {
    var vuse = v;
    if ( vuse===-1234 ) vuse = vold[i].value;
    return (<tr key={i}><td>&nbsp;&nbsp;</td><td>{dip.paras[i].name}</td><td>
                      <input value={vuse} type='text'  onChange={(e) => this.dip(name,e)} ></input>
                          </td></tr> );
  }

  renderstress(stress,i,name,v,vold)
  {
    var vuse = v;
    if ( vuse===-1234 ) vuse = vold[i].value;

    var utip='';
    if ( typeof stress.paras[i].tip!=='undefined' )
    {
      utip = stress.paras[i].tip;
    }

    if ( name==='apply' )
    {
      var opts = ['no','yes'];
      var listopts=opts.map((opt) => <option key={opt} value={opt}>{opt}</option> );
      var selected = opts[vuse];

      return (<tr key={i}><td>&nbsp;&nbsp;</td><td>{stress.paras[i].name}</td><td>
              <div className="builddrop" data-tooltip-id="blue" data-tooltip-content={utip}>
                <select value={selected} onChange={(e) => this.apply(e)} >
                {listopts}
              </select></div></td></tr>
          );
    }
    else
    {
      return (<tr key={i}><td>&nbsp;&nbsp;</td><td>{stress.paras[i].name}</td><td data-tooltip-id="blue" data-tooltip-content={utip}>
              <input value={vuse} type='text'  onChange={(e) => this.stress(name,e)} ></input>
                  </td></tr> );
    }
  }

  apply(e)
  {
    var newstate = Object.assign(this.state);
    newstate.stresssol.apply = e.target.selectedIndex;
    this.setState(newstate);
  }

  logs()
  {
    var newstate = Object.assign(this.state);
    newstate.showlogs = true;
    this.setState(newstate);
  }

  showdip()
  {
    var newstate = Object.assign(this.state);
    newstate.showdip = true;
    this.setState(newstate);
  }

  showstress()
  {
    var newstate = Object.assign(this.state);
    newstate.showstress = true;
    this.setState(newstate);
  }


  closelogs()
  {
    var newstate = Object.assign(this.state);
    newstate.showlogs = false;
    this.setState(newstate);
  }

  closedip(data,qupdate)
  {
    if ( qupdate )
    {
      var i = 0;
      for ( var key in this.state.dip )
      {
        if ( this.state.dip[key]!==-1234 ) data[i].value = parseFloat(this.state.dip[key]); i++;
      }
      this.props.onTrigger();
    }
    var newstate = Object.assign(this.state);
    newstate.showdip = false;
    this.setState(newstate);
  }

  dip(key,e)
  {
    var newstate = Object.assign(this.state);
    newstate.dip[key] = e.target.value;
    this.setState(newstate);
  }


  closestress(data,qupdate,fsel)
  {
    var newstate = Object.assign(this.state,fsel);
    if ( qupdate )
    {
      var i = 0;
      for ( var key in this.state.stresssol )
      {
        if ( this.state.stresssol[key]!==-1234 )
        {
          if ( i<4 ) data[i].value = parseFloat(this.state.stresssol[key]);
          else       data[i].value = parseInt(this.state.stresssol[key]);
        }
        i++;
        newstate.stresssol[key] = -1234;
      }
      for ( var j=0; j<DATA.Reservoirs[fsel].data.stresssol.length; j++ )
      {
        DATA.Reservoirs[fsel].data.stresssol[j].para[4].value = data[4].value;
      }

      this.props.onTrigger();
    }
    newstate.showstress = false;
    this.setState(newstate);
  }


  stress(key,e)
  {
    var newstate = Object.assign(this.state);
    newstate.stresssol[key] = e.target.value;
    this.setState(newstate);
  }

  import()
  {
    this.inputRef.current.click();
  }
}

class Geosheet extends React.Component
{
  constructor(props)
  {
    super(props);
    this.sheets=[{ sheetName: 'Thickness & Tops' },
                 { sheetName: 'Porosity' },
                 { sheetName: 'Permeability' }];

    //{
    //    sheetName: 'Thickness',
    //                 data:[["fred",2,3,3.5],["joe",5,6,6.5]],
    //                 minDimensions:[10,10],
    //                 columns: [
    //                  { title: 'Layer' },
    //                  { title: 'Well_one'  , width: 100 },
    //                  { title: 'Well_two'  , width: 100 },
    //                  { title: 'Well_three', width: 100 },
    //                    ]
    //},
    //{
    //    sheetName: 'Permeability',
    //                 data:[["fred",20,30],["joe",50,60]],
    //                 minDimensions:[10,10],
    //                 columns: [
    //                  { title: 'Layer' },
    //                  { title: 'Well_one'  , width: 100 },
    //                  { title: 'Well_two'  , width: 100 },
    //                  { title: 'Well_three', width: 100 },
    //                    ]
    //},
    //{
    //    sheetName: 'Porosity',
    //                 data:[["fred",0.2,0.3,0.25],["joe",0.15,0.16,0.1]],
    //                 minDimensions:[10,10],
    //                 columns: [
    //                  { title: 'Layer' },
    //                  { title: 'Well_one'  , width: 100 },
    //                  { title: 'Well_two'  , width: 100 },
    //                  { title: 'Well_three', width: 100 },
    //                    ]
    //},
    //{
    //    sheetName: 'Net-to-Gross',
    //                 data:[["fred",1,0.9,0.98],["joe",0.8,0.7,0.6]],
    //                 minDimensions:[10,10],
    //                 columns: [
    //                  { title: 'Layer' },
    //                  { title: 'Well_one'  , width: 100 },
    //                  { title: 'Well_two'  , width: 100 },
    //                  { title: 'Well_three', width: 100 },
    //                    ]
    //}
    //  ];
    this.wrapper = React.createRef();
  }

  componentDidMount = function()
  {
    this.el = jexcel.tabs(this.wrapper.current, this.sheets);
  };

  addRow = function()
  {
    var worksheet = this.wrapper.current.children[0].querySelector('.selected').getAttribute('data-spreadsheet');
    this.wrapper.current.jexcel[worksheet].insertRow();
  };

  save = function()
  {
    var logs={};
    for ( var i=0; i<this.wrapper.current.jexcel.length; i++ )
    {
      var data = this.wrapper.current.jexcel[i].getData(false);
      if ( i===0 ) logs.thick        = data;
      if ( i===1 ) logs.porosity     = data;
      if ( i===2 ) logs.permeability = data;
    }
    this.props.formation[0].logs = logs;
    this.props.tomain();
  }

  render()
  {
    if ( typeof this.props.formation[0].logs==='undefined' ) this.initialize();
    else this.set(this.props.formation[0].logs);

    return (
      <div className="runbuttons">
       <div ref={this.wrapper}  />
        <br />
        <input
          type='button'
          value='save'
          onClick={() => this.save()}
          style={{width: '100px'}}
        />&nbsp;
        <input
          type='button'
          value='cancel'
          onClick={() => this.props.tomain()}
          style={{width: '80px'}}
        />&nbsp;
  {/*      <input
          type='button'
          value='Add new row'
          onClick={() => this.addRow()}
        /> */}
      </div>
    );
  }

  set(logs)
  {
    for ( var is=0; is<this.sheets.length; is++ )
    {
      this.headers(is);

      if ( is===0 ) this.sheets[is].data = logs.thick;
      if ( is===1 ) this.sheets[is].data = logs.porosity;
      if ( is===2 ) this.sheets[is].data = logs.permeability;
    }
  }

  headers(is)
  {
    if ( is===0 )
    {
      var columns = [{ title: 'Layer', width: 100 }];
      for ( var iw=0; iw<this.props.wells.length; iw++ )
      {
        var well={ width: 100 };
        well.title = this.props.wells[iw].name;
        columns.push(well);
      }
      this.sheets[is].columns = columns;
    }
    else
    {
      var headers = [{ title: 'Layer', colspan: 1 }];
      columns = [{ title: 'Top', width: 100 }];
      for ( iw=0; iw<this.props.wells.length; iw++ )
      {
        well={ width: 100 };
        well.title = this.props.top;
        columns.push(well);
        well={ colspan: 1 };
        well.title =  this.props.wells[iw].name;
        headers.push(well);
      }
      this.sheets[is].columns = columns;
      this.sheets[is].nestedHeaders = [headers];
    }
  }


  initialize()
  {
    for ( var is=0; is<this.sheets.length; is++ )
    {
      this.headers(is);

      var data = [];
      if ( is===0 )
      {
        data.push([]);
        data = [['Top Depth']];
        for ( var iw=0; iw<this.props.wells.length; iw++ )
        {
          data[0].push(this.props.top);
        }
      }
      for ( var il=0; il<this.props.layers.length; il++ )
      {
        data.push([this.props.layers[il].name]);
        for ( iw=0; iw<this.props.wells.length; iw++ )
        {
          var value = 0.0;
          if ( is===0 ) value=this.props.layers[il].para[1].value;
          else
          {
            var rock = this.props.layers[il].para[2].value;
            for ( var ir=0; ir<this.props.rock.length; ir++ )
            {
              if ( rock===this.props.rock[ir].name )
              {
                var poroperm = this.props.rock[ir].para[0].value;
                for ( var ip=0; ip<this.props.poroperm.length; ip++ )
                {
                  if ( poroperm===this.props.poroperm[ip].name )
                  {
                    if ( is===1 ) value = this.props.poroperm[ip].para[0].value;
                    if ( is===2 ) value = this.props.poroperm[ip].para[1].value;
                    break;
                  }
                }
                if ( value>0 ) break;
              }
            }
          }
          data[data.length-1].push(value);
        }
      }
      this.sheets[is].data = data;
    }
  }
}

class Names extends React.Component
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props)
  }
  render()
  {
    var names = this.props.names.slice();
    for ( var i=0; i<names.length; i++ )
    {
      if ( this.props.types[i]!=='' ) names[i]+=' ('+this.props.types[i]+')';
    }
    const listopts=names.map((d,i) => <option key={i} value={d}>{d}</option> );

    return (
      <div className={this.props.class}>
        <select value={[names[this.props.nameindex]]} multiple={true} onChange={(e) => this.handleChange(e) }>
          {listopts}
        </select>
      </div>
    );
  }

  handleChange(event)
  {
    this.props.handleChange(event);
  }

}

class Types extends React.Component
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props)
  }
  render()
  {
    const type = this.props.type;
    return (
      <div className="types">
        <span style={{color: 'red'}} >&nbsp;{type}
        </span>
      </div>
    );
  }
}

class Parameter extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state = { value: '', sensitive: 0, edited: false, newitem: false, itemname: '' };
  }

  render()
  {
    var name = this.props.name;

    if ( m_dunits && typeof this.props.unit!=='undefined' && this.props.unit!=='' && this.props.unit!=='none' )
    {
      var u = new Units();
      name += '('+u.units[this.props.unit][m_unit]+')';
    }

    var value = this.state.value;
    if ( (value==='' || this.props.reset) && !this.state.edited ) value = this.props.value;

    var sens = this.state.sensitive;
    if ( sens===0 && typeof this.props.sensitivity!=='undefined' ) sens = this.props.sensitivity;
    var colour = '';
    if ( sens===1 ) colour = 'orange';

    var what = '';
    if ( this.props.readonly )
    {
      if ( typeof this.props.tip!=='undefined' )
      {
        if ( this.props.obj!=='' )
        {
          what = <><input readOnly type="text" value={value}  className='objectro' data-tooltip-id="blue" data-tooltip-content={this.props.tip} />></>;
        }
        else  what = <><input readOnly type="text" value={value}  className='ro' data-tooltip-id="gray" data-tooltip-content={this.props.tip} />></>;
      }
      else
      {
        if ( this.props.obj!=='' ) what = <input readOnly type="text" value={value}  className='objectro' />;
        else                       what = <input readOnly type="text" value={value}  className='ro' />;
      }
    }
    else
    {
      if ( typeof this.props.tip!=='undefined' )
      {
        if ( this.props.obj!=='' )
        {
          var list = ['']; if ( this.props.obj==='frac' || this.props.obj==='production' ) list = ['none'];
          var sect = SIXXCS[this.props.obj].sect;
          var file = 0; if ( typeof this.props.fileselected[sect]!=='undefined' ) file = this.props.fileselected[sect];
          for ( var i=0; i<DATA[sect][file].data[this.props.obj].length; i++ )
          {
            list.push(DATA[sect][file].data[this.props.obj][i].name);
          }
          list.push('<new item>');
          const listopt=list.map((string) => <option key={string} value={string}>{string}</option> );

          what = <> <select value={value} onChange={(e) => this.selection(e) } className='objectro' >
                     {listopt}
                    </select></>;
        }
        else  what = <><input type="text" value={value}
                        onChange={(e) => this.onChange(e)} onBlur={(e) => this.onBlur(e)}
                        data-tooltip-id="gray" data-tooltip-content={this.props.tip} /></>;
      }
      else
      {
        if ( this.props.obj!=='' ) what = <input type="text" value={value} onChange={(e) => this.onChange(e)} className='object' />;
        else                       what = <input type="text" value={value} onChange={(e) => this.onChange(e)} />;
      }
    }

    var tip = 'click for later use as a sensitivity parameter';
    var tipid = 'sensitivityyes';
    if ( typeof this.props.sen !== 'undefined' && !this.props.sen )
    {
      tip = 'parameter not currently available as a sensitivity parameter ';
      tipid = 'sensitivityno';
    }

    return (<><tr><td><span onClick={() => this.makesensitive()} style={{ color: colour }} data-tooltip-id={tipid} data-tooltip-content={tip} >{name}</span></td><td>
      <div className="parameter">
      <form key={this.props.formkey} onSubmit={(e) => this.handleSubmit(e) }>
        <label>
            {what}
        </label>
      </form>
      </div>
      </td></tr>
      <ReactModal isOpen={this.state.newitem} appElement={document.getElementById('root')}  className="Modal"  >
        <div style={{ background: this.props.colour }} >
          <table><tbody><tr><td>New {this.props.obj}
          <form onSubmit={(e) => this.addnew(e)} >
            <table><tbody><tr>
              <td><input  value={this.state.name} onChange={(e) => this.updatenew(e)} /></td>
              <td><input type="submit" value="add"></input></td>
              <td><span onClick={() => this.closeModal()} >&times;</span></td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            </tbody></table>
          </form></td>
        </tr></tbody></table>
      </div>
      </ReactModal></>
      );
  }

  selection(e)
  {
    var newstate = Object.assign(this.state);
    if ( e.target.value==='<new item>' ) newstate.newitem = true;
    newstate.value = e.target.value;
    newstate.edited = true;
    this.setState(newstate);

    this.props.onChange(e.target.value);
  }

  onBlur(e)
  {
    var newstate = Object.assign(this.state);
    newstate.edited = false;
    this.setState(newstate);

    this.props.handleSensChange(e);

    this.props.onSubmit();
  }

  onChange(e)
  {
    if ( Number.isFinite(this.props.value) )
    {
      var n = parseFloat(e.target.value);
      if ( !Number.isFinite(n) && e.target.value!=='-' && e.target.value!=='' )
      {
        global.alertx("Number required",true);
        e.target.value = this.props.value;
      }
    }

    var newstate = Object.assign(this.state);
    newstate.edited = e.target.value!=='';
    newstate.value = e.target.value;
    this.setState(newstate);

    this.props.onChange(e.target.value);
  }

  handleSubmit(e)
  {
    var newstate = Object.assign(this.state);
    newstate.edited = false;
    this.setState(newstate);

    e.preventDefault();
    this.props.onSubmit();
  }

  makesensitive()
  {
    if ( typeof this.props.sen!=='undefined' && !this.props.sen ) return;

    if ( m_debug ) global.alertx("Hi makesensitive",false);
    var newstate = Object.assign(this.state);

    var sens = this.state.sensitive;
    if ( sens===0 && typeof this.props.sensitivity!=='undefined' ) sens = this.props.sensitivity;

    if      ( sens===0 ) newstate.sensitive=1;
    else if ( sens===1 ) newstate.sensitive=2;
    else if ( sens===2 ) newstate.sensitive=1;

    this.setState(newstate);
    this.props.makesensitive(newstate.sensitive);
  }

  closeModal()
  {
    var newstate = Object.assign(this.state);
    newstate.newitem=false;
    this.setState(newstate);
  }

  updatenew(event)
  {
    var newstate = Object.assign(this.state);
    newstate.itemname=event.target.value;
    this.setState(newstate);
  }

  addnew(event)
  {
    if ( this.state.itemname!=='' )
    {
      this.handleNewitem(this.state.itemname);
    }
    else
    {
      global.alertx("Name required",true);
    }
    this.closeModal();
  }

  handleNewitem(newname)
  {
    var sect = SIXXCS[this.props.obj].sect;
    var file = 0; if ( typeof this.props.fileselected[sect]!=='undefined' ) file = this.props.fileselected[sect];

    var paras = SIXXCS[this.props.obj].paras;

    var newpara=[];
    for ( var i=0; i<paras.length; i++ )
    {
      newpara.push({ value: paras[i].value, sensitive: 0});
    }

    var newitem={ name: newname, type: 'simple', para: newpara };

    if ( this.props.obj==='geomech' ) DATA[sect][file].data.stresssol.push(copyobj(STARTDATA.stresssol[0]));

    for ( i=0; i<DATA[sect][file].data[this.props.obj].length; i++ )
    {
      if ( newitem.name===DATA[sect][file].data[this.props.obj][i].name )
      {
        global.alertx("Duplicate name: "+newitem.name,true);
        return;
      }
    }

    DATA[sect][file].data[this.props.obj].push(newitem);

    var newstate = Object.assign(this.state);
    newstate.value = newname;
    this.setState(newstate);

    this.props.onChange(newname);
  }

}

class Parameterset extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state={ nnew: 0, showModal: false, itemname: '', sensselected: 0, prevsensselected: 0, rename: false };
  }

  render()
  {
    const sixxc = this.props.sixxc;
    const data  = this.props.data;
    const paras = this.props.paras;

    if ( typeof this.props.paravalues[sixxc]==='undefined' ) // initialize parameter values store
    {
      var pv = new Array(paras.length);
      pv.fill(null);
      this.props.paravalues[sixxc]=pv;

      var sn = new Array(paras.length);
      sn.fill(0);
      this.props.parasensitivity[sixxc]=sn;
    }

    var nbsize=3; if ( sixxc==='single' || sixxc==='sensitivity' ) nbsize = LISTSECT.length-1;
    var nblock = parseInt((paras.length-1)/nbsize)+1; if ( sixxc==='sensitivity' ) nblock++;
    var blocks = new Array(nblock);
    blocks.fill(null);
    for ( var i=0; i<nblock; i++ )
    {
      blocks[i]=i;
    }
    var listblocks =blocks.map((v,index) => this.renderblock(index,nbsize) );

    const listnames= data[sixxc].map( (v) => v.name );
    const listtypes= data[sixxc].map( (v) => v.type );

    var findex=0;
    if ( typeof this.props.nameindex[sixxc]!=='undefined' ) findex=this.props.nameindex[sixxc];
    if ( findex>=data[sixxc].length ) findex=0;

    var shownames=true; if ( sixxc==='single' || sixxc==='sensitivity' ) shownames=false;

    var adda = 'add'; if ( this.state.rename ) adda = 'rename';
    var addt = 'New'; if ( this.state.rename ) addt = 'Rename';

    if ( sixxc==='sensitivity' )
    {
      var parasens = this.sensitivities(this.state.sensselected);
      for ( i=data[sixxc][0].para.length-3; i<data[sixxc][0].para.length; i++ )
      {
        if ( data[sixxc][0].para[i].value.length < parasens.length ) data[sixxc][0].para[i].value[parasens.length-1]='';
      }
    }

    return (
      <div className='parameterset'>
        <table><tbody><tr><td>
          {shownames? <Middle listnames={listnames} findex={findex} sixxc={sixxc} listtypes={listtypes}
                              fileselected={this.props.fileselected} paras={this.props.paras} colour={this.props.colour}
                              nameindex={this.props.nameindex}
                              handleChange={(i) => this.handleChange(i)}
                              add={(i) => this.add(i,false)}
                              deleteitem={(i) => this.deleteitem(i)}
                              rename={(i) => this.add(i,true)}
                              importfile={(e) => this.importfile(e)}
                              onTrigger={() => this.props.onTrigger()} />:
            <Build sections={STRUCTURE.sections}
                   selected={this.props.fileselected}
                   report={this.props.report}
                   sixxc={sixxc}
                   sensselected={this.state.sensselected}
                   submit={() => this.onSubmit()}
                   handleNewitem={(n) => this.handleNewitem(n)}
                   sensitivities={() => this.sensitivities(-2)}
                   trigger={() => this.props.onTrigger()} /> }
       </td><td> <table><tbody><tr>{listblocks}</tr></tbody></table> </td>
        </tr></tbody></table>
      <ReactModal isOpen={this.state.showModal} appElement={document.getElementById('root')}  className="Modal"  >
        <div style={{ background: this.props.colour }} >
            <table><tbody><tr><td>{addt} {sixxc}
          <form onSubmit={(e) => this.addnew(e)} >
            <table><tbody><tr>
              <td><input  value={this.state.name} onChange={(e) => this.updatenew(e)} /></td>
              <td><input type="submit" value={adda}></input></td>
              <td><span onClick={() => this.closeModal()} >&times;</span></td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            </tbody></table>
          </form></td>
        </tr></tbody></table>
      </div>
      </ReactModal>
      </div>
    );

  }

  add(i,rename)
  {
    const sixxc = this.props.sixxc;
    var data    = this.props.data;
    var paravalues = this.props.paravalues[sixxc];
    var parasensitivity = this.props.parasensitivity[sixxc];
    var nameindex = 0;
    if ( typeof this.props.nameindex[sixxc]!=='undefined' ) nameindex = this.props.nameindex[sixxc];

    Submit(paravalues,parasensitivity,data[sixxc],nameindex,'Parameterset:add',data.revision);

    if ( sixxc==='geomech' ) data.stresssol.push(copyobj(STARTDATA.stresssol[0]));

    var newstate = Object.assign(this.state);
    newstate.itemname='';
    newstate.showModal=true;
    newstate.rename = rename;
    this.setState(newstate);
  }

  closeModal()
  {
    var newstate = Object.assign(this.state);
    newstate.showModal=false;
    this.setState(newstate);
  }

  updatenew(event)
  {
    var newstate = Object.assign(this.state);
    newstate.itemname=event.target.value;
    this.setState(newstate);
  }

  addnew(event)
  {
    if ( this.state.rename )
    {
      const sixxc = this.props.sixxc;
      const data  = this.props.data;
      var nameindex = 0;
      var err=false;
      if ( typeof this.props.nameindex[sixxc]!=='undefined' )
      {
        nameindex = this.props.nameindex[sixxc];

        err=false;
        for ( var i=0; i<data[sixxc].length; i++ )
        {
          if ( this.state.itemname===data[sixxc][i].name )
          {
            global.alertx("Duplicate name: "+this.state.itemname,true);
            err = true;
          }
        }
      }
      if ( !err )
      {
        if ( typeof SIXXCS[sixxc].rcomp !== 'undefined' )
        {
          if ( typeof data[SIXXCS[sixxc].rcomp.sixc] !== 'undefined' )
          {
            for ( i=0; i<data[SIXXCS[sixxc].rcomp.sixc].length; i++ )
            {
              if ( data[SIXXCS[sixxc].rcomp.sixc][i].para[SIXXCS[sixxc].rcomp.para].value === data[sixxc][nameindex].name )
                data[SIXXCS[sixxc].rcomp.sixc][i].para[SIXXCS[sixxc].rcomp.para].value =  this.state.itemname;
            }
          }
        }
        data[sixxc][nameindex].name = this.state.itemname;
      }
    }
    else if ( this.state.itemname!=='' )
    {
      this.handleNewitem(this.state.itemname);
    }
    else
    {
      global.alertx("Name required",true);
    }
    this.closeModal();
  }

  handleChange(event)
  {
    this.onSubmit();
    this.props.handleNameindex(this.props.sixxc,event.target.selectedIndex);
  }

  handleNewitem(newname)
  {
    const sixxc = this.props.sixxc;
    const data  = this.props.data;

    var newstate = Object.assign(this.state);

    newstate.nnew++;

    var newpara=[];
    for ( var i=0; i<this.props.paras.length; i++ )
    {
      var defaultval = this.props.paras[i].value;
      if ( this.props.paras[i].name==='order' ) defaultval = data[sixxc].length+1; // special case
      newpara.push({ value: defaultval, sensitive: 0});
    }

    var newitem={ name: newname, type: 'simple', para: newpara };

    for ( i=0; i<data[sixxc].length; i++ )
    {
      if ( newitem.name===data[sixxc][i].name )
      {
        global.alertx("Duplicate name: "+newitem.name,true);
        return;
      }
    }

    data[sixxc].push(newitem);
    this.props.nameindex[sixxc] = data[sixxc].length-1;

    this.onSubmit();

    //
    // Action and Production default to last well/completions
    //
    if ( sixxc==='schedule' )
    {
      var fracs  = SIXXCS['frac'].paras;

      var wells = DATA[SIXXCS['well'].sect][DATA[SIXXCS['well'].sect].length-1].data['well'];
      if ( wells.length>0 ) data[sixxc][data[sixxc].length-1].para[0].value = wells[wells.length-1].name;

      if ( typeof DATA[SIXXCS['completion'].sect]!=='undefined' &&
          typeof DATA[SIXXCS['completion'].sect][DATA[SIXXCS['completion'].sect].length-1].data['completion']!=='undefined' )
      {
        var comps = DATA[SIXXCS['completion'].sect][DATA[SIXXCS['completion'].sect].length-1].data['completion'];
        if ( comps.length>0 ) data[sixxc][data[sixxc].length-1].para[1].value = comps[comps.length-1].name;
      }
      else if ( typeof DATA[SIXXCS['frac'].sect]!=='undefined' &&
                typeof DATA[SIXXCS['frac'].sect][DATA[SIXXCS['frac'].sect].length-1].data['frac']!=='undefined' )
      {
        fracs = DATA[SIXXCS['frac'].sect][DATA[SIXXCS['frac'].sect].length-1].data['frac'];
        if ( fracs.length>0 ) data[sixxc][data[sixxc].length-1].para[1].value = fracs[fracs.length-1].name;
      }
    }

    var alertmsg = cascadingdefaults(sixxc,data);

    if ( alertmsg!=='' ) global.alertx(' The following dependent data has been added:\n'+alertmsg,false);

    this.props.handleNameindex(this.props.sixxc,data[sixxc].length-1);

    this.props.onTrigger();
  }

  deleteitem()
  {
    const sixxc = this.props.sixxc;
    const data  = this.props.data;
    if ( typeof this.props.nameindex[sixxc]!=='undefined' )
    {
      var nameindex = this.props.nameindex[sixxc];
      data[sixxc].splice(nameindex,1);
    }
    if ( typeof this.props.nameindex[sixxc]==='undefined' ) this.props.nameindex[sixxc]=0;
    this.props.nameindex[sixxc] = Math.max(this.props.nameindex[sixxc]-1,0);

    var newstate = Object.assign(this.state);
    newstate.nnew++;
    this.setState(newstate);

    this.props.onTrigger();
  }

  importfile(evt)
  {
    var files = evt.target.files; // FileList object

    for ( var i=0; i<files.length; i++ )
    {
      var f = files[i];
      var name = f.name.substring(0,f.name.search("[.]"));
      var reader = new FileReader();
      var read={ names: name, reader: reader, source: this };

      if      ( read.source.props.sixxc==='well'  ) read.reader.onload = this.onloadimportjsonwell(name,read);
      else if ( read.source.props.sixxc==='fluid' ) read.reader.onload = this.onloadimportpvt(name,read);
      else global.alertx('problem with import');

      read.reader.onerror = function(event)
      {
        global.alertx("File could not be read",true);
      }

      read.reader.readAsText(f);
    }
  }

  onloadimportjsonwell(name,read)
  {
    return function(event)
    {
      var contents = event.target.result;

      //
      // Strip stuff before and after {} - e.g. RKSJSON & /
      //
      contents = contents.substring(contents.search('{'));
      contents = contents.substring(0,contents.lastIndexOf('}')+1);

      try
      {
        var jin = JSON.parse(contents);
      } catch(e) {  alert(e); }

      var tv4 = require('tv4');

      var s = new Wellgeo(m_compopt,STARTDATA.constants);

      var schema = s.getwellschema();

      // Test the data is valid against the schema's definition
      var valid = tv4.validate(jin, schema);

      var j = { data: jin };

      if ( valid )
      {
        global.alertx("json file: "+name+" is valid & loaded ",false);

        for ( var i=0; i<j.data.wells.length; i++ )
        {
          j.data.wells[i].type = 'imported';
          j.data.wells[i].prnt = 'YES';
        }

        const sixxc = read.source.props.sixxc;
        const data  = read.source.props.data;

        var newstate = Object.assign(read.source.state);

        newstate.nnew++;

        for ( var jw=0; jw<j.data.wells.length; jw++ )
        {
          for ( i=0; i<data[sixxc].length; i++ )
          {
            if ( j.data.wells[jw].name===data[sixxc][i].name )
            {
              global.alertx("Duplicate well name: "+j.data.wells[jw].name,true);
              return;
            }
          }
        }

        for ( i=0; i<j.data.wells.length; i++ )
        {
          // Dummy parameters to keep things happy, in particular to allow stages in imported fracs
          j.data.wells[i].para = [];
          for ( var ip=0; ip<SIXXCS['well'].paras.length; ip++ )
          {
            j.data.wells[i].para.push({value: 0, sensitive: 0});
          }
          data[sixxc].push(j.data.wells[i]);
        }
        read.source.props.nameindex[sixxc] = data[sixxc].length-1;

        read.source.onSubmit();

        var fsel = 0; if ( typeof read.source.props.fileselected[SIXXCS['frac'].sect]!=='undefined' ) fsel = read.source.props.fileselected[SIXXCS['frac'].sect];
        var fsect = DATA[SIXXCS['frac'].sect][fsel];

        for ( var iw=0; iw<j.data.wells.length; iw++ )
        {
          var wname = j.data.wells[iw].name;
          if ( typeof j.data.wells[iw].completions==='undefined' ) continue;
          var nstage = j.data.wells[iw].completions.length;
          if ( nstage>0 )
          {
            var frac={name: wname+'_frac', nstage: nstage, type: 'imported'};
            // Dummy para for stages
            frac.para = [];
            for ( ip=0; ip<SIXXCS['well'].paras.length; ip++ )
            {
               frac.para.push({ value: nstage, sensitive: 0});
            }
            fsect.data.frac.push(frac);
          }
        }

        read.source.setState(newstate);
      }
      else
      {
        global.alertx(" json file "+name+" is invalid - please check ",true);
      }
    }
  }

  onloadimportpvt(name,read)
  {
    return function(event)
    {
      var contents = event.target.result;
      var j = JSON.parse(contents);

      var tv4 = require('tv4');

      var s = new Wellgeo(m_compopt,STARTDATA.constants);

      var schema = s.getpvtschema();

      // Test the data is valid against the schema's definition
      var valid = tv4.validate(j, schema);

      if ( valid )
      {
        global.alertx("json file: "+name+" is valid & loaded ",false);

        j.type = "pvtjson";

        const sixxc = read.source.props.sixxc;
        const data  = read.source.props.data;

        data[sixxc][0].data = j;
        data[sixxc][0].name = name;
        data[sixxc][0].type = 'imported';

        read.source.props.handleNameindex(sixxc,0);

      }
      else
      {
        global.alertx(" pvt file "+name+" is invalid - please check ",true);
      }
    }
  }

  renderpara(i,b)
  {
    const sixxc = this.props.sixxc;
    const data  = this.props.data;
    const paras = this.props.paras;
    const filen = this.props.file;

    var findex=0;
    if ( typeof this.props.nameindex[sixxc]!=='undefined' ) findex=this.props.nameindex[sixxc];

    if ( data[sixxc].length>0 )
    {
      if ( findex>=data[sixxc].length ) findex=0;
      if ( typeof data[sixxc][findex].type!=='undefined' && data[sixxc][findex].type==='imported' )
      {
        if ( sixxc!=='frac' || i!==3 ) return <tr key={b+filen+data[sixxc][findex].type+findex+i}></tr>;
      }
    }

    var value=' ';
    var sens=0;
    if ( findex>0 || sixxc==='sensitivity' ) value=paras[i].value; // default

    if ( findex<data[sixxc].length && i<data[sixxc][findex].para.length )
    {
      value = data[sixxc][findex].para[i].value;
      sens  = data[sixxc][findex].para[i].sensitive
    }

    var readonly = data[sixxc].length===0;

    if ( typeof this.props.paras[i].drop!=='undefined' && this.props.paras[i].drop )
    {
      var listopts=[];
      var selected='';

      if ( this.props.paras[i].name!=='para' )
      {
        //
        // Drop down - not sensitivity
        //
        listopts=DATA[this.props.paras[i].name].map((sect) => <option key={sect.name} value={sect.name}>{sect.name}</option> );
        if ( value<DATA[this.props.paras[i].name].length) selected=DATA[this.props.paras[i].name][value].name;

        return (<tr key={b+filen+this.props.paras[i].name+this.props.nameindex[sixxc]}><td>{this.props.paras[i].name}</td>
                <td>
                <div className="builddrop">
                 <select value={selected} onChange={(e) => this.onChangesect(e,i)} >
                 {listopts}
                </select></div></td></tr>
            );
      }
      else
      {
        //
        // Sensitivity special
        //
        var parasens = this.sensitivities(this.state.sensselected);
        const listnames= parasens.map( (v) => v.string );
        var types=new Array(listnames.length);
        types.fill('');

        return (
          <tr key={listnames} ><td><div className='checkbuild'>
          <table><tbody><tr><td>
               <Names  names={listnames} nameindex={this.state.sensselected} sixxc={'sensitivity'}
                      types={types} class={'sensitivities'}
                      handleChange={(i) => this.handleSensChange(i)} />
           </td></tr></tbody></table>
          </div></td></tr>
          );
      }
    }
    else if ( typeof this.props.paras[i].array!=='undefined' && this.props.paras[i].array )
    {
      var colour = '';
      if ( this.props.paras[i].comp!=='' ) colour = STRUCTURE.sections[SIXXCS[this.props.paras[i].comp].sect].colour;

      var sval = ' ';
      if ( findex<data[sixxc].length && i<data[sixxc][findex].para.length )
      {
        sval = data[sixxc][findex].para[i].value[this.state.sensselected];
      }

      //
      // min/max/N parameter
      //
      return (<Parameter key={b+filen+this.props.paras[i].name+this.props.nameindex[sixxc]}
                         name={this.props.paras[i].name} value={sval} sensitivity={false} readonly={readonly}
                         obj={this.props.paras[i].comp} reset={true}
                         tip={this.props.paras[i].utip}
                         sen={this.props.paras[i].sen}
                         unit={this.props.paras[i].unit}
                         colour={colour}
                         fileselected={this.props.fileselected}
                         onChange={(d) => this.onChange(i,d)}
                         onSubmit={() => this.onSubmitsens()}
                         makesensitive={(d) => this.makesensitive(i,d)}
                         handleSensChange={(i) => this.handleSensChange(i)} /> );
    }
    else
    {
      colour = '';
      if ( this.props.paras[i].comp!=='' ) colour = STRUCTURE.sections[SIXXCS[this.props.paras[i].comp].sect].colour;

      //
      // Regular parameter
      //
      return (<Parameter key={b+filen+this.props.paras[i].name+this.props.nameindex[sixxc]}
                         name={this.props.paras[i].name} value={value} sensitivity={sens} readonly={readonly}
                         obj={this.props.paras[i].comp} reset={false}
                         tip={this.props.paras[i].utip}
                         sen={this.props.paras[i].sen}
                         unit={this.props.paras[i].unit}
                         colour={colour}
                         fileselected={this.props.fileselected}
                         onChange={(d) => this.onChange(i,d)}
                         onSubmit={() => this.onSubmit()}
                         makesensitive={(d) => this.makesensitive(i,d)}
                         handleSensChange={(i) => this.handleSensChange(i)} /> );
    }
  }

  renderblock(b,nbsize)
  {
    const paras = this.props.paras;
    var nbatch = Math.min(nbsize,paras.length-b*nbsize);
    var ioff=0;

    // Cludge
    if ( b===1 && this.props.paras[nbsize*b].name==='para' ) nbatch=1;
    if ( b>1 && this.props.paras[nbsize].name==='para' ) { ioff=nbsize-1; nbatch=3; }
    // End cludge

    var batch = new Array(nbatch);
    for ( var j=0; j<nbatch; j++ )
    {
      batch[j]=b*nbsize+j-ioff;
    }
    const listparas =batch.map((value,index) => this.renderpara(value,b) );
    return (<td key={b}><table><tbody>{listparas}</tbody></table></td> );
  }

  onChange(i,d)
  {
    const sixxc = this.props.sixxc;
    this.props.paravalues[sixxc][i]=d;
  }

  handleSensChange(event)
  {
    var newstate = Object.assign(this.state);
    newstate.prevsensselected = this.state.sensselected;
    if ( typeof event.target.selectedIndex!=='undefined' ) newstate.sensselected = event.target.selectedIndex;
    this.setState(newstate);
  }

  onChangesect(event,i)
  {
    var newstate = Object.assign(this.state);
    if ( this.props.paras[i].name==='sensitivity' )
    {
      newstate.prevsensselected = this.state.sensselected;
      newstate.sensselected = event.target.selectedIndex;
    }
    newstate.nnew++;
    this.setState(newstate);

    const sixxc = this.props.sixxc;
    this.props.paravalues[sixxc][i]=event.target.selectedIndex;

    this.onSubmit();
  }

  onSubmit()
  {
    const sixxc = this.props.sixxc;
    var data    = this.props.data;
    var paravalues = this.props.paravalues[sixxc];
    var parasensitivity = this.props.parasensitivity[sixxc];
    var nameindex = 0;
    if ( typeof this.props.nameindex[sixxc]!=='undefined' ) nameindex = this.props.nameindex[sixxc];

    Submit(paravalues,parasensitivity,data[sixxc],nameindex,'Parameterset',data.revision);

    this.props.onTrigger();
  }


  onSubmitsens()
  {
    const sixxc = this.props.sixxc;
    var data    = this.props.data;
    var paravalues = this.props.paravalues[sixxc];
    var nameindex = 0;
    if ( typeof this.props.nameindex[sixxc]!=='undefined' ) nameindex = this.props.nameindex[sixxc];

    Submitsens(paravalues,data[sixxc],nameindex,this.state.prevsensselected);

    this.props.onTrigger();
  }

  makesensitive(i,d)
  {
    const sixxc = this.props.sixxc;
    this.props.parasensitivity[sixxc][i]=d;
  }

  sensitivities(selected)
  {
    var data = DATA;

    var sectnames =  Object.keys(STRUCTURE.sections);

    var lista=[];

    for ( var i=0; i<sectnames.length; i++ )
    {
      if ( sectnames[i]==='build' ) continue;

      var section = STRUCTURE.sections[sectnames[i]];
      var build  = STRUCTURE.sections.build.sixcs[1].paras;
      var buildd = this.props.data.sensitivity[0].para;

      var sel = 0;
      for ( var j=0; j<4; j++ )
      {
        if ( build[j].name===section.key ) { sel = buildd[j].value; break;}
      }

      var j1=sel;
      var j2=sel+1;
      if ( m_debug ) { j1=0; j2=data[sectnames[i]].length; }

      for ( j=j1; j<j2; j++ )
      {

        for ( var k=0; k<section.sixcs.length; k++ )
        {
          var sixxc     = section.sixcs[k];
          var sixxcdata = data[sectnames[i]][j].data[sixxc.name];

          for ( var l=0; l<sixxcdata.length; l++ )
          {
            var para = sixxcdata[l].para;
            if ( typeof para==='undefined' ) continue;

            for ( var m=0; m<para.length; m++ )
            {
              if ( typeof para[m].sensitive!=='undefined' && para[m].sensitive===1 )
              {
                var s1 = sixxc.name+':'+sixxcdata[l].name;
                var s2 = new Array(21-s1.length).join(' ');
                var s3 = sixxc.paras[m].name+' '+para[m].value;
                var string = s1+s2+s3;
                lista.push({string: string, value: para[m].value, sixxc: section.sixcs[k], num: l, para: m});

                if ( lista.length===selected+1 )
                {
                  if ( para[m].value===0 )
                  {
                    SIXXCS['sensitivity'].paras[4].value=1;
                    SIXXCS['sensitivity'].paras[5].value=-1;
                  }
                  else
                  {
                    SIXXCS['sensitivity'].paras[4].value=para[m].value*2;
                    SIXXCS['sensitivity'].paras[5].value=para[m].value/2;
                  }
                }
              }
            }
          }
        }
      }
    }

    return lista;
  }

}


//
// Managefile - deals with the "files" for all Sections
//
class Managefile extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state = { showModel: false, name: '', copynumber: {} };
  }
  render()
  {
    return (
      <div className="filebuttons">
      <table><tbody><tr>
        <td><button onClick={(e) => this.handleOpenModal() } >rename</button></td>
        <td><button onClick={(e) => this.copy(e) }   >copy</button></td>
        <td><button onClick={(e) => this.delete(e) } >delete</button></td>
        <td><button onClick={(e) => this.export(e) } >export</button></td>
        <ReactModal isOpen={this.state.showModal} appElement={document.getElementById('root')} className="Modal"  >
        <div style={{ background: this.props.colour }} >
          <table><tbody><tr><td>Rename {this.props.name}
          <form onSubmit={(e) => this.rename(e)} >
            <table><tbody><tr>
              <td><input  value={this.state.name} onChange={(e) => this.onChange(e)} /></td>
              <td><input type="submit" value="go"></input></td>
              <td><span onClick={() => this.handleCloseModal()} >&times;</span></td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            </tbody></table>
          </form></td>
        </tr></tbody></table>
      </div>
      </ReactModal>
        <ReactModal isOpen={this.state.showDel} appElement={document.getElementById('root')} className="Modal"  >
        <div style={{ background: this.props.colour }} >
            <form>
          <table><tbody><tr><td>&nbsp;</td></tr>
           <tr><td>Delete {this.props.name} : {this.props.data.name} ?</td><td>&nbsp;</td>
                  <td><button onClick={() => this.actualdel(this.props.sect) } >ok</button></td>
                  <td><button onClick={() => this.cancel()    } >cancel</button></td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
         </tbody></table></form>
      </div>
      </ReactModal>
      </tr></tbody></table>
      </div>
    );
  }

  delete()
  {
    var newstate = Object.assign(this.state);
    newstate.showDel = true;
    this.setState(newstate);
  }

  cancel()
  {
    var newstate = Object.assign(this.state);
    newstate.showDel = false;
    this.setState(newstate);
  }

  handleOpenModal ()
  {
    var newstate = Object.assign(this.state);
    newstate.name=this.props.data.name;
    newstate.showModal=true;
    this.setState(newstate);
  }

  handleCloseModal ()
  {
    var newstate = Object.assign(this.state);
    newstate.showModal=false;
    this.setState(newstate);
  }

  onChange(event)
  {
    var newstate = Object.assign(this.state);
    newstate.name=event.target.value;
    this.setState(newstate);
  }

  rename(e)
  {
    this.props.onTrigger();
    var qerr=false;
    for ( var i=0; i<this.props.alldata.length; i++ )
    {
      if ( this.props.alldata[i].name===this.state.name )
      {
        global.alertx('duplicate name ('+this.state.name+')',true);
        qerr = true;
        break;
      }
    }
    if ( !qerr ) this.props.data.name=this.state.name;
    this.handleCloseModal();
  }

  copy(e)
  {
    this.props.onTrigger();
    var serial = JSON.stringify(this.props.data);
    var newdata = JSON.parse(serial);
    var copyn = 1;
    var basename = newdata.name;
    if ( basename.indexOf('(')>0 ) basename = basename.substr(0,basename.indexOf('('));
    if ( typeof this.state.copynumber[basename]!=='undefined' )
    {
      copyn=this.state.copynumber[basename];
      copyn++;
      newdata.name = basename+'('+copyn.toString()+')';
    }
    else
    {
      newdata.name += '('+copyn.toString()+')';
    }
    this.props.alldata.push(newdata);

    var newstate = Object.assign(this.state);
    newstate.copynumber[basename]=copyn;
    this.setState(newstate);

    this.props.handleFileChange(this.props.alldata.length-1);
  }

  actualdel(sect)
  {
    var bp=-1;
    for ( var i=0; i<LISTSECT.length; i++ )
    {
      if ( sect===LISTSECT[i] ) bp = i;
    }

    for( i=0; i<this.props.alldata.length; i++)
    {
      if ( this.props.alldata[i].name===this.props.data.name && this.props.alldata.length>1 )
      {
        this.props.alldata.splice(i, 1);
        if ( bp>=0 && sect!=='build' )
        {
          //
          // Delete build references to this file
          //
          for ( var ifl=0; ifl<DATA['build'].length; ifl++ )
          {
            if ( DATA['build'][ifl].data['single'][0].para[bp].value===i ) DATA['build'][ifl].data['single'][0].para[bp].value=0;
            if ( DATA['build'][ifl].data['single'][0].para[bp].value>i   ) DATA['build'][ifl].data['single'][0].para[bp].value--;
          }
        }
        this.props.handleFileChange(0);
        break;
      }
    }
    this.props.onTrigger();

    var newstate = Object.assign(this.state);
    newstate.showDel = false;
    this.setState(newstate);
  }

  export(event)
  {
    var serial = JSON.stringify(this.props.data);

    if ( this.props.export==='.bld' )
    {
      if ( typeof this.props.data.dataset!=='undefined' )
      {
        var file =  this.props.data.name+'.data';
        global.SaveAsFile(this.props.data.dataset,file);
        global.alertx(file+' downloaded ',false);
      }
      else
      {
        global.alertx('dataset not built ',false);
      }
    }
    else
    {
      file =  this.props.data.name+this.props.export;
      global.SaveAsFile(serial,file);
      global.alertx(file+' downloaded ',false);
    }
  }
}

//
// Section - deals with the models main screen:
//                      Getfile/Managefile  sixxc (6x concepts)
//                                          Parameterset
//
class Section extends React.Component
{
  constructor(props)
  {
    super(props);

    this.state = { selected: SECTIONCOUNT, nameindex: {}, trigger: '', copynumber: {} };
    this.inputRef = React.createRef();
  }

  render()
  {
    const sect = this.props.structure.key;
    const paras = this.props.structure.sixcs[this.state.selected[sect]].paras;

    const files = this.props.section.map( (v) => v.name );
    var   file = 0; if ( typeof this.props.fileselected[sect]!='undefined' &&
                                this.props.fileselected[sect]<this.props.section.length ) file = this.props.fileselected[sect];
    var   data  = this.props.section[file].data;

    const sixxc = this.props.structure.sixcs[this.state.selected[sect]].name;

    if ( sect!=="build" ) this.props.report.go = false;

    this.props.sixxcandindex.sixxc=this.state.selected[sect];   // communicate upwards
    this.props.sixxcandindex.index=this.state.nameindex[sixxc];

    return (
      <div style={{ background: this.props.structure.colour }} className="section" >
        <table><tbody>
          <tr><td><global.Header title={this.props.structure.title} /></td><td><global.Selected fileselected={this.props.fileselected} sect={sect} /></td></tr>
          <tr><td rowSpan="2"><global.File files={files} selected={file} onChange={(e) => this.handleFileChange(e) } /></td><td>
          <div className="sixcs">
          <table><tbody><tr>
            <Sixxcs selected={this.state.selected[sect]} sixcs={this.props.structure.sixcs}  onClick={(i) => this.handleClick(i)} />
          </tr></tbody></table>
          </div>
          <Parameterset sixxc={sixxc} data={data} paras={paras} file={file} colour={this.props.structure.colour}
                                     paravalues={this.props.paravalues}
                                     parasensitivity={this.props.parasensitivity}
                                     nameindex={this.state.nameindex}
                                     fileselected={this.props.fileselected}
                                     report={this.props.report}
                                     handleNameindex={(s,i) => this.handleNameindex(s,i)}
                                     onTrigger={() => this.props.onTrigger()} /></td></tr>
        </tbody></table>
        <table><tbody>
          <tr><td><global.Getfile name={this.props.structure.thing} onClick={(i) => this.handleNewFile(i)} />
            <div className="hidden" > <input type={'file'} ref={this.inputRef} value={''}
                                                accept={this.props.structure.import}
                                                onChange={(e) => this.handleFileSelect(e)} ></input> </div></td>
            <td><Managefile name={this.props.structure.thing}
                            export={this.props.structure.export}
                            sect={sect}
                            data={this.props.section[file]}
                            colour={this.props.structure.colour}
                            alldata={this.props.section}
                            report={this.props.report}
                            handleFileChange={(i) =>this.props.handleFileChange(sect,i)}
                            onTrigger={(i) => this.trigger(i)} /></td></tr>
        </tbody></table>
      </div>
    );
  }

  trigger()
  {
    var newstate = Object.assign(this.state);
    newstate.trigger++;
    this.setState(newstate);
  }

  handleClick(i)
  {
    this.submitdata();

    const sect = this.props.structure.key;
    var newstate = Object.assign(this.state);
    newstate.selected[sect]=i;
    this.props.onTrigger(i);
    this.setState(newstate);
  }

  handleFileChange(event)
  {
    this.submitdata();

    const sect = this.props.structure.key;
    this.props.handleFileChange(sect,event.target.selectedIndex);
  }

  submitdata()
  {
    const sect = this.props.structure.key;
    var file = 0; if ( typeof this.props.fileselected[sect]!='undefined' ) file = this.props.fileselected[sect];

    const sixxc = this.props.structure.sixcs[this.state.selected[sect]].name;
    var   data  = this.props.section[file].data;
    var paravalues = this.props.paravalues[sixxc];
    var parasensitivity = this.props.parasensitivity[sixxc];
    var nameindex = 0;
    if ( typeof this.state.nameindex[sixxc]!=='undefined' ) nameindex = this.state.nameindex[sixxc];

    Submit(paravalues,parasensitivity,data[sixxc],nameindex,'Section',data.revision);

    this.props.onTrigger();
  }

  handleNameindex(sixxc,i)
  {
    var newstate = Object.assign(this.state);
    newstate.nameindex[sixxc]=i;
    this.setState(newstate);
  }

  handleNewFile()
  {
    this.inputRef.current.click();
  }

  handleFileSelect (evt)
  {
    var files = evt.target.files; // FileList object

    for ( var i=0; i<files.length; i++ )
    {
      var f = files[i];
      var name = f.name.substring(0,f.name.search("[.]"));
      var reader = new FileReader();
      var read={ names: name, reader: reader, section: this.props.section, source: this };

      read.reader.onload = this.onload(name,read,this);

      read.reader.onerror = function(event)
      {
        global.alertx("File could not be read",true);
      }

      read.reader.readAsText(f);
    }
  }

  onload(name,read,host)
  {
    return function(event)
    {
      var contents = event.target.result;
      var j = JSON.parse(contents);
      j.name = name;

      for ( var i=0; i<read.section.length; i++ )
      {
        if ( read.section[i].name===name )
        {
          var copyn = 1;
          if ( typeof host.state.copynumber[name]!=='undefined' ) copyn=host.state.copynumber[name];
          j.name += copyn.toString();
          copyn++;

          var newstate = Object.assign(host.state);
          newstate.copynumber[name]=copyn;
          host.setState(newstate);

          break;
        }
      }

      read.section.push(j);

      const sect = read.source.props.structure.title;
      read.source.props.handleFileChange(sect,read.section.length-1);
    }
  }

}

class Menu extends React.Component
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props);
  }
  render()
  {
    const sects = this.props.sections;
    const sel = this.props.sel;
    const listsect=sects.map( function(sect,index)
    {
      if ( index===sel )
      {
        return (<tr key={index}><td> <button onClick={() => this.props.onClick(index) } ><i><b>{sect}</b></i></button></td></tr>);
      }
      else
      {
        return (<tr key={index}><td> <button onClick={() => this.props.onClick(index) } >{sect}</button></td></tr>);
      }
    }, this );

    return (
        <table><tbody>
         {listsect}
        </tbody></table>
    );
  }

};

//
// Prog - main program
//
// Handle the lhs menu - main (Section/Rplot/Runscreen)
//                     - plot (Wgplot/Dplot/Pyplot/Error)
//
class Prog extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state={ section: 0, fileselected: {}, trigger: 0,  paravalues: {}, parasensitivity:{},
                 sixxcandindex: [ { sixxc: 0, index: 0 }, { sixxc: 0, index: 0 }, { sixxc: 0, index: 0 }, { sixxc: 0, index: 0 }, { sixxc: 0, index: 0 } ],
                 plotstate: { qplot: false, qwellplot: 0 },
                 jobs: [], queues: [], queue: 0,
                 showModel: false,
                 units: 'field',
                 awslambda: false,
                 awsstatus: 'cloud',
                 server: m_server,
                 devcmd: m_devcmd,
                 outer: 'models',
                 classic: false};
    this.inputRef = React.createRef();
  }


  render()
  {
    global.common.data      = DATA;
    global.common.structure = STRUCTURE;
    global.common.sixxcs    = SIXXCS;
    global.common.listsect  = LISTSECT;

    var sectnames =  Object.keys(this.props.structure);

    if ( this.state.section<3 ) this.props.report.text='';

    var u = new Units();

    var curunits=u.set[m_unit];
    const listunits=u.set.map((string) => <option key={string} value={string}>{string}</option> );

    var listsect=<Section structure={STRUCTURE.sections[sectnames[this.state.section]]}
                          section={DATA[sectnames[this.state.section]]}
                          fileselected={this.state.fileselected}
                          paravalues={this.state.paravalues}
                          parasensitivity={this.state.parasensitivity}
                          sixxcandindex={this.state.sixxcandindex[this.state.section]}
                          report={this.props.report}
                          handleFileChange={(s,i) => this.handleFileChange(s,i)}
                          onTrigger={(i) => this.onTrigger(i)}  />;
    var plot=<plotter.Rplot structure={OTHERS.plotter} onPlot={(s) => this.renderPlot(s)}
                    state={this.state.plotstate} jobs={this.state.jobs} processjobs={(r) => this.jobs(r)}
                    showwellgeo={() => this.showwellgeo()}
                    login={() => this.swaptorun()} />
    var run=<Runscreen structure={OTHERS.run} rundata={this.state.jobs} buildfile={this.state.fileselected['build']}
             build={DATA['build']} jobs={(r) => this.jobs(r)}
             awsstatus={this.state.awsstatus} setaws={(a,b) => this.setaws(a,b)}
             queues={this.state.queues} queue={this.state.queue}
             setqueues={(r) => this.queues(r)} setqueue={(r) => this.queue(r)}/>
    var models = <div className="leftmenu" >
          <table><tbody><tr><td>
            <Menu sel={this.state.section} sections={sectnames}  onClick={(i) => this.handleClick(i)} />
          </td></tr>
          <tr><td>
          </td></tr>
          <tr><td>
            <table><tbody><tr><td>
              <button  onClick={() => this.saveload('save') } >save</button>
             </td></tr><tr><td>
              <button  onClick={() => this.saveload('load') } >load</button>
              <div className="hidden" > <input type={'file'} ref={this.inputRef} accept={'.6xproj'} onChange={(e) => this.handleFileSelect(e)} ></input> </div>
            </td></tr><tr><td>
              <button  onClick={() => this.handleOpenModal() } >options</button>
              <ReactModal
                 isOpen={this.state.showModal}
                 appElement={document.getElementById('root')}
                 className="Options"  >
                <table><tbody><tr><td>Options</td><td></td><td></td><td>&nbsp;&nbsp;</td><td><span onClick={() => this.handleCloseModal()} >&times;</span></td></tr>
                <tr><td></td></tr>
                <tr><td>&nbsp;&nbsp;</td><td>Unit convention</td><td>
                           <select value={curunits} onChange={(e) => this.optionunits(e)} >
                             {listunits}
                          </select>
                            <span className="alignright">display?</span></td><td>
                          <form>
                      <input id={'dunits'} type={'checkbox'} checked={m_dunits} onChange={(e) => this.optiondunits(e)} ></input>
                           </form>
                          </td></tr>
                <tr><td>&nbsp;&nbsp;</td><td>Use Perforation Flow model</td><td>
                          <form>
                            <input id={'perfflow'} type={'checkbox'} checked={m_perfflow} onChange={(e) => this.optionperfflow(e)} ></input>
                           </form>
                          </td></tr>
                <tr><td>&nbsp;&nbsp;</td><td>Completions version</td><td>
                          <form>
                            <input id={'compopt'} type={'checkbox'} checked={m_compopt} onChange={(e) => this.optioncompletions(e)} ></input>
                           </form>
                          </td></tr>
           {/*     <tr><td>&nbsp;&nbsp;</td><td>Classic version</td><td>
                          <form>
                            <input id={'classicopt'} type={'checkbox'} checked={this.state.classic} onChange={(e) => this.optionskin(e)} ></input>
                           </form>
                          </td></tr> */}
                <tr><td>&nbsp;&nbsp;</td><td>Server</td><td>
                          <form>
                      <input value={this.state.server} type={'text'}  onChange={(e) => this.option2(e)} ></input>
                           </form>
                          </td></tr>
                <tr><td>&nbsp;&nbsp;</td><td>devcmd</td><td>
                          <form>
                      <input value={m_devcmd} type={'text'}  onChange={(e) => this.option3(e)} ></input>
                           </form>
                          </td></tr>
                <tr><td>&nbsp;&nbsp;</td><td><span data-tooltip-id="gray" data-tooltip-content="Runs a small job (one core, <15mins) in the cloud - returning alony the summary data">lambda fnc</span></td><td>
                          <form>
                      <input id={'awslambda'} type={'checkbox'} checked={this.state.awslambda} onChange={(e) => this.option4(e)} ></input>
                           </form></td><td><><span data-tooltip-id="gray" data-tooltip-content="Runs a small job (one core, <15mins) in the cloud - returning alony the summary data">Single core (cloud)</span></>
                          </td></tr>
                <tr><td>&nbsp;&nbsp;</td><td>Notes</td><td>
                          <form>
                      <input id={'classicopt'} type={'checkbox'} checked={this.props.qnotes} onChange={(e) => this.props.notes(e)} ></input>
                           </form>
                          </td></tr>
                <tr><td>&nbsp;&nbsp;</td><td>Completion output</td><td>
                          <form>
                      <input id={'classicopt'} type={'checkbox'} checked={m_rkscomp} onChange={(e) => this.optionrkscomp(e)} ></input>
                           </form>
                          </td></tr>
                <tr><td>&nbsp;&nbsp;</td></tr>
                <tr><td>&nbsp;&nbsp;</td><td>About: </td><td>#{m_svn}
                          </td></tr>
                <tr><td></td></tr>
                    <tr><td></td><td><button onClick={() => this.handleCloseModal() } style={{ width: '80px' }} >ok</button></td></tr>
                </tbody></table>
              </ReactModal>
            </td></tr>
            </tbody></table>
          </td></tr>
          </tbody></table>
      </div>;

    var rhs = models;
    if      ( this.state.outer==='run'  ) rhs = run;
    else if ( this.state.outer==='plot' ) rhs = plot;

    var display = <div>&nbsp;</div>;
    if      ( this.state.outer==='plot' )
    {
      if ( this.state.plotstate.qwellplot===2 )
      {
        display=<table><tbody><tr><td><plotter.Pyplot qtwo={true} qplot={this.state.plotstate.qplot} /></td>
                                  <td><Wgplot structure={STRUCTURE.sections[sectnames[0]]}
                                                         section={DATA[sectnames[0]]}
                                                         fileselected={global.common.srv.selected} qplot={true} />
                </td></tr></tbody></table>;
      }
      else if ( this.state.plotstate.qwellplot===1 )
      {
        display = <Wgplot structure={STRUCTURE.sections[sectnames[0]]}
                          section={DATA[sectnames[0]]}
                          fileselected={global.common.srv.selected} qplot={true} />;
      }
      else if ( m_d3 )
      {
        display = <plotter.Dplot  localstate={this.state.plotstate} onPlot={() => this.trip()} />;
      }
      else
      {
        display=<plotter.Pyplot qtwo={false} qplot={this.state.plotstate.qplot} />;
      }
    }
    else if ( this.state.outer==='run' && m_user!=='none' ) display = <global.Jobs jobs={this.state.jobs} getmodel={0} />;
    else if ( this.state.outer==='run') display = <div></div>;
    else if ( LISTSECT[this.state.section]===SIXXCS['well'].sect  ||
              LISTSECT[this.state.section]===SIXXCS['layer'].sect ||
              LISTSECT[this.state.section]===SIXXCS['frac'].sect   )
      display = <Wgplot structure={STRUCTURE.sections[sectnames[this.state.section]]}
                        section={DATA[sectnames[this.state.section]]}
                        fileselected={this.state.fileselected} qplot={false} />;
    else if ( LISTSECT[this.state.section]==='build' ) display = <Error report={this.props.report}/>;
    //else if ( LISTSECT[this.state.section]==='Scenarios' ) display = <Timeplot />;

    var structure = STRUCTURE.sections[sectnames[this.state.section]];
    const sixxc = structure.sixcs[this.state.sixxcandindex[this.state.section].sixxc].name;

    return (
<>
      <table><tbody><tr><td>
      <table><tbody><tr>
          <td><Outer what={(s) => this.outer(s) } sixxc={sixxc} /></td><td>
          { rhs }

      </td><td>
      { this.state.outer==='models' ?
      <div className="section" >
          {listsect}
      </div> : <></> }
      </td></tr></tbody></table>

      </td></tr><tr><td>
          {display}
       </td></tr></tbody></table>

<div>
<Tooltip
  id="blue" style={{ place: "top", backgroundColor: "SlateBlue", effect: "float", delayShow: 500 }}
/>
<Tooltip
  id="gray" style={{ place: "top", backgroundColor: "gray", effect: "float", delayShow: 500 }}
/>
<Tooltip
  id="sensitivityyes" style={{ place: "top", backgroundColor: "#ffc266", effect: "solid", delayShow: 2000 }}
/>
<Tooltip
  id="sensitivityno" style={{ place: "top", backgroundColor: "#ffc266", effect: "solid", delayShow: 1000 }}
/>
</div>
</>


);

  }

  trip()
  {
    var newstate = Object.assign(this.state);
    newstate.plotstate.qplot = false;
    this.setState(newstate);
  }

  jobs(response)
  {
    var newstate = Object.assign(this.state);
    newstate.jobs = response;
    newstate.jobs.reverse();
    this.setState(newstate);
  }

  renderPlot(state)
  {
    var newstate = Object.assign(this.state);
    newstate.plotstate.qplot = state.qplot;
    this.setState(newstate);
  }

  outer(s)
  {
    var newstate = Object.assign(this.state);
    newstate.outer = s;
    if ( this.state.outer==='plot'&&s.outer!=='plot' )
    {
      newstate.plotstate.qwellplot=0;
      global.common.srv={};
    }
    else
    {
      newstate.plotstate.qplot = false;
    }
    this.setState(newstate);
    var w = s;
    if ( s==='models' )
    {
      var sectnames =  Object.keys(this.props.structure);
      w = sectnames[this.state.section];
    }
    this.props.where(w);
  }

  swaptorun()
  {
    var newstate = Object.assign(this.state);
    newstate.outer='run';
    this.setState(newstate);
    this.props.where('run');
  }

  onTrigger(i)
  {
    var newstate = Object.assign(this.state);
    newstate.trigger++;
    if ( typeof i!=='undefined' ) newstate.sixxcandindex[newstate.section].sixxc = i;
    this.setState(newstate);
  }

  handleClick(i)
  {
    this.submitdata();
    var newstate = Object.assign(this.state);
    newstate.section=i;
    this.setState(newstate);
    var sectnames =  Object.keys(this.props.structure);
    this.props.where(sectnames[i]);
  }

  handleFileChange(sect,fileindex)
  {
    var newstate = Object.assign(this.state);
    newstate.fileselected[sect]= fileindex;
    this.setState(newstate);
  }

  submitdata()
  {
    var sectnames =  Object.keys(this.props.structure);
    if ( this.state.section>=sectnames.length ) return; // "run" et al

    var section = DATA[sectnames[this.state.section]];
    var structure = STRUCTURE.sections[sectnames[this.state.section]];
    const sect = structure.key;
    var file = 0; if ( typeof this.state.fileselected[sect]!='undefined' &&
                              this.state.fileselected[sect]<section.length ) file = this.state.fileselected[sect];

    const sixxc = structure.sixcs[this.state.sixxcandindex[this.state.section].sixxc].name;
    var   data  = section[file].data;
    var paravalues      = this.state.paravalues[sixxc];
    var parasensitivity = this.state.parasensitivity[sixxc];
    var nameindex = 0;
    if ( typeof this.state.sixxcandindex[this.state.section].index!=='undefined' ) nameindex = this.state.sixxcandindex.index;

    Submit(paravalues,parasensitivity,data[sixxc],nameindex,'Prog',data.revision);
  }

  saveload(which)
  {
    if ( which==='save' )
    {
      this.submitdata();

      var sectnames =  Object.keys(this.props.structure);
      var w = sectnames[this.state.section];
      this.props.where(w);

      var date = new Date();
      var d = date.toString().substring(0,24);
      d = d.replace(/ /g, '_');

      var serial=JSON.stringify(DATA,null,2);
      global.SaveAsFile(serial,d+'.6xproj');
      global.alertx('6x project file downloaded: '+d+'.6xproj',false);
    }
    else
    {
      this.inputRef.current.click();
      var newstate = Object.assign(this.state);
      newstate.fileselected = {};
      this.setState(newstate);
    }
  }

  handleFileSelect (evt)
  {
    var files = evt.target.files; // FileList object

    for ( var i=0; i<files.length; i++ )
    {
      var f = files[i];
      var name = f.name.substring(0,f.name.search("[.]"));
      var reader = new FileReader();
      var read={ name: name, reader: reader, source: this };

      read.reader.onload = this.onload(name,read,this);

      read.reader.onerror = function(event)
      {
        global.alertx("File could not be read",true);
      }

      read.reader.readAsText(f);
    }
  }

  onload(name,read,host)
  {
    return function(event)
    {
      var contents = event.target.result;
      var data = JSON.parse(contents);

      read.source.handleFileChange(STRUCTURE.sections[0],0);

      var projectui = '';
      if ( typeof data.options.ui !=='undefined' ) projectui = data.options.ui;
      if ( data.version<34000 )                    projectui = 'classic';

      if ( projectui!==m_uitype )
      {
        global.alertx('Incompatible project - project:'+projectui+' ui:'+m_uitype);
        return;
      }
      else
      {
        global.alertx('Project '+read.name+' (version: '+data.version+') loaded',false);
        DATA = data;
      }
      var sectnames =  Object.keys(host.props.structure);
      host.props.where(sectnames[host.state.section],'load');

      if ( DATA.version>33000 ) m_unit     = DATA.options.units;
      if ( DATA.version>33020 ) m_compopt  = DATA.options.completions;
      if ( DATA.version>33020 ) m_perfflow = DATA.options.perfflow;
      if ( DATA.version>34729 ) m_devcmd   = DATA.options.devcmd;
      if ( DATA.version>35384 ) m_dunits   = DATA.options.dunits;
      if ( DATA.version>35551 ) m_rkscomp  = DATA.options.rkscomp; else DATA.options.rkscomp=false;

      //
      // Back compatibility (back compat,BACK COMP,BACKCOMP - for grep!)
      //
      if ( m_uitype==='classic' )
      {

        if ( DATA.version<33275 )
        {
          DATA.build[0].data.constants.sigmacomp =  {  value:    1e-6, unit: 'sigmacomp'       };
          DATA.build[0].data.constants.rockcfact =  {  value:    0.33, unit: 'none'            };
          DATA.build[0].data.constants.sigprop   =  {  value:     0.5, unit: 'none'            };
          DATA.build[0].data.constants.partden   =  {  value:     160, unit: 'density'         };
        }
        for ( var i=0; i<DATA.build.length; i++ )
        {
          if ( DATA.build[0].data.sensitivity[0].para.length===6 ) DATA.build[0].data.sensitivity[0].para.push({ value: 3, sensitive: 0 });
        }

        for ( i=0; i<DATA.properties.length; i++ )
        {
          if ( typeof DATA.properties[i].data.geomech === 'undefined' &&
               typeof DATA.properties[i].data.strength !== 'undefined' ) DATA.properties[i].data.geomech = DATA.properties[i].data.strength;

          for ( var j=0; j<DATA.properties[i].data.geomech.length; j++ )
          {
            if ( DATA.properties[i].data.geomech[j].para.length===3 )
            {
              DATA.properties[i].data.geomech[j].para.push(DATA.properties[i].data.geomech[j].para[2]);
              DATA.properties[i].data.geomech[j].para[2] = DATA.properties[i].data.geomech[j].para[1];
              DATA.properties[i].data.geomech[j].para[1] = DATA.properties[i].data.geomech[j].para[0];
              DATA.properties[i].data.geomech[j].para[0] = { value: 0.0, sensitivity: false }
            }
          }

          for ( j=0; j<DATA.properties[i].data.poroperm.length; j++ )
          {
            if(DATA.properties[i].data.poroperm[j].para[2]<0.0001) DATA.properties[i].data.poroperm[j].para[2].value = 1;
            else                                                   DATA.properties[i].data.poroperm[j].para[2].value = 2;
          }

          DATA.build[0].data.constants.ffrac = { value: 0.005, unit: 'none' };

        }
      }
      else
      {
        if ( DATA.version<34403 && typeof DATA.Reservoirs!=='undefined' )
        {
          for ( i=0; i<DATA.Reservoirs.length; i++ )
          {
            for ( j=0; j<DATA.Reservoirs[i].data.scal.length; j++ )
            {
              if ( DATA.Reservoirs[i].data.scal[j].para.length===8 )
              {
                DATA.Reservoirs[i].data.scal[j].para.push({value: 1, sensitivity: false});
              }
            }
          }
        }
        if ( DATA.version<34475 && typeof DATA.Scenarios!=='undefined' )
        {
          for ( i=0; i<DATA.Scenarios.length; i++ )
          {
            for ( j=0; j<DATA.Scenarios[i].data.schedule.length; j++ )
            {
              if ( DATA.Scenarios[i].data.schedule[j].para.length===4 )
              {
                DATA.Scenarios[i].data.schedule[j].para[2].value = DATA.Scenarios[i].data.schedule[j].para[3].value;
                for ( var ii=0; ii<DATA.FracJobs.length; ii++ )
                {
                  for ( var k=0; k<DATA.FracJobs[ii].data.frac.length; k++ )
                  {
                    if ( DATA.FracJobs[ii].data.frac[k].name===DATA.Scenarios[i].data.schedule[j].para[1].value )
                    {
                      DATA.FracJobs[ii].data.frac[k].para[3].value = DATA.FracJobs[ii].data.stages[DATA.Scenarios[i].data.schedule[j].para[2].value].name;
                    }
                  }
                }
              }
            }
          }
        }

        if ( DATA.version<34565 && typeof DATA.Scenarios!=='undefined' )
        {
          for ( i=0; i<DATA.Scenarios.length; i++ )
          {
            for ( j=0; j<DATA.Scenarios[i].data.production.length; j++ )
            {
              if ( DATA.Scenarios[i].data.production[j].para.length===4 )
              {
                DATA.Scenarios[i].data.production[j].para.push({value: 5, sensitivity: false });
              }
            }
          }
        }
        if ( DATA.version<34729 )
        {
          for ( i=0; i<DATA.Reservoirs.length; i++ )
          {
            for ( j=0; j<DATA.Reservoirs[i].data.geomech.length; j++ )
            {
              if ( DATA.Reservoirs[i].data.geomech[j].para.length===4 )
              {
                DATA.Reservoirs[i].data.geomech[j].para.push({value: 0, sensitivity: false });
                DATA.Reservoirs[i].data.geomech[j].para.push({value: 4.97, sensitivity: false });
              }
            }
          }
          for ( i=0; i<DATA.FracJobs.length; i++ )
          {
            for ( j=0; j<DATA.FracJobs[i].data.stages.length; j++ )
            {
              if ( DATA.FracJobs[i].data.stages[j].para.length===4 )
              {
                DATA.FracJobs[i].data.stages[j].para.push({value: 12000, sensitivity: false });
              }
            }
          }
          for ( i=0; i<DATA.build.length; i++ )
          {
            if ( typeof DATA.build[i].data.constants.depleat==='undefined' )
            {
              DATA.build[i].data.constants.depleat = { value: 10000, unit: 'pressure' };
            }
          }
        }
        if ( DATA.version<34730 )
        {
          for ( i=0; i<DATA.build.length; i++ )
          {
            if ( DATA.options.units===0 && DATA.build[i].data.constants.partden.value!==165 ) DATA.build[i].data.constants.partden.value = 165;
          }
        }
        if ( DATA.version<35310 )
        {
          for ( i=0; i<DATA.build.length; i++ )
          {
            if ( DATA.options.units===0 && Math.abs(DATA.build[i].data.constants.sigprop.value-0.15)>0.00001 ) DATA.build[i].data.constants.sigprop.value = 0.15;
            for ( var key in DATA.build[i].data.constants )
            {
              DATA.build[i].data.constants[key].comment = STARTDATA.constants[key].comment;
            }
          }
        }

        if ( DATA.version<35384 )
        {
          for ( i=0; i<DATA.FracJobs.length; i++ )
          {
            for ( j=0; j<DATA.FracJobs[i].data.stages.length; j++ )
            {
              DATA.FracJobs[i].data.stages[j].para[0].value = parseFloat(DATA.FracJobs[i].data.stages[j].para[0].value)/(60*24);
            }
          }
        }

        if ( DATA.version<35551 )
        {
          for ( i=0; i<DATA.Reservoirs.length; i++ )
          {
            DATA.Reservoirs[i].data.dip = STARTDATA.dip;
          }
          for ( i=0; i<DATA.build.length; i++ )
          {
            DATA.build[i].data.constants.minfporo = { value:  0.0001, unit: 'none' ,comment: 'minimum fracture porosity' }
          }
        }

        if ( DATA.version<36000 )
        {
          for ( i=0; i<DATA.build.length; i++ )
          {
            DATA.build[i].data.sensitivity[0].para[5].value = [];
            DATA.build[i].data.sensitivity[0].para[6].value = [];
            DATA.build[i].data.sensitivity[0].para[7].value = [];
          }
        }

        if ( DATA.version<37043 )
        {
          for ( i=0; i<DATA.Reservoirs.length; i++ )
          {
            DATA.Reservoirs[i].data.stresssol = STARTDATA.stresssol;
            for ( j=1; j<DATA.Reservoirs[i].data.geomech.length; j++ )
            {
              DATA.Reservoirs[i].data.stresssol.push(STARTDATA.stresssol[0]);
            }
          }
        }

      }

      DATA.version = m_svn; // update to program svn
      completionsmode(m_compopt);
      host.trip();
    }
  }

  handleOpenModal ()
  {
    var newstate = Object.assign(this.state);
    newstate.showModal=true;
    this.setState(newstate);
  }

  handleCloseModal ()
  {
    var newstate = Object.assign(this.state);
    newstate.showModal=false;
    this.setState(newstate);
  }

  optionperfflow(e)
  {
    var newstate = Object.assign(this.state);
    m_perfflow = e.target.checked;
    DATA.options.perfflow = m_perfflow;
    this.setState(newstate);
  }

  optiondunits(e)
  {
    var newstate = Object.assign(this.state);
    m_dunits = e.target.checked;
    DATA.options.dunits = m_dunits;
    this.setState(newstate);
  }

  optioncompletions(e)
  {
    var newstate = Object.assign(this.state);
    m_compopt = e.target.checked;
    global.common.compopt = m_compopt;
    completionsmode(m_compopt);
    DATA.options.completions = m_compopt;
    DATA.options.perfflow    = m_perfflow;
    this.setState(newstate);
  }

  optionrkscomp(e)
  {
    var newstate = Object.assign(this.state);
    m_rkscomp = e.target.checked;
    DATA.options.rkscomp = m_rkscomp;
    this.setState(newstate);
  }

  optionskin(e)
  {
    var newstate = Object.assign(this.state);
    newstate.classic = e.target.checked;
    if ( newstate.classic ) this.props.changeskin('classic');
    else                    this.props.changeskin('alun');
    this.setState(newstate);
  }

  optionunits(e)
  {
    var newstate = Object.assign(this.state);
    newstate.units = e.target.selectedIndex;
    convert(newstate.units);
    DATA.options.units = m_unit;
    this.setState(newstate);
  }

  option2(e)
  {
    var newstate = Object.assign(this.state);
    newstate.server = e.target.value;
    m_server = e.target.value;
    m_remoteserver = m_server;
    global.common.server = m_server;
    this.setState(newstate);
  }

  option3(e)
  {
    var newstate = Object.assign(this.state);
    newstate.devcmd = e.target.value;
    m_devcmd = e.target.value;
    DATA.options.devcmd = m_devcmd;
    this.setState(newstate);
  }

  option4(e)
  {
    var newstate = Object.assign(this.state);
    newstate.awslambda = e.target.checked;
    m_awslambda = newstate.awslambda;
    this.setState(newstate);
  }

  showwellgeo()
  {
    var newstate = Object.assign(this.state);
    if      ( this.state.plotstate.qwellplot===0 ) newstate.plotstate.qwellplot = 1;
    else if ( this.state.plotstate.qwellplot===1 ) newstate.plotstate.qwellplot = 2;
    else                                           newstate.plotstate.qwellplot = 0;
    newstate.plotstate.qplot=false;
    this.setState(newstate);
  }

  setaws(aws)
  {
    var newstate = Object.assign(this.state);
    newstate.awsstatus=aws;
    this.setState(newstate);
  }

  queues(result)
  {
    var newstate = Object.assign(this.state);
    newstate.queues =  result;
    this.setState(newstate);
  }

  queue(e)
  {
    var newstate = Object.assign(this.state);
    newstate.queue = e.target.selectedIndex;
    this.setState(newstate);
  }

};

//
// Skin
//
// Handles the different versions - Prog
//
class Skin extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state={ type: 'alun', location: 'Reservoirs', qnotes: true }
    this.notesRef = React.createRef();
  }

  render()
  {

    if ( typeof DATA.notes==='undefined' ) DATA.notes = {};
    if ( typeof DATA.notes[this.state.location]==='undefined') DATA.notes[this.state.location] = '';
    if ( this.notesRef.current!==null ) this.notesRef.current.state.text = DATA.notes[this.state.location];

    m_server = window.location.href; m_server = m_server.substring(0, m_server.length - 1);
    if ( m_server.search("build/index.html") >0 ) m_server = m_server.substring(0,m_server.search("build/index.html")); 
    if ( m_server.search("build/index.htm") >0 ) m_server = m_server.substring(0,m_server.search("build/index.htm")); 
    if ( global.isElectron() ) m_server = 'http://5.154.189.2:55555';
    if ( m_remoteserver==='' )
    {
      m_remoteserver = m_server;
      global.common.server  = m_server;
    }

    return <div className="skin"> <table><tbody><tr><td className='dependencylink'><Prog data={DATA} structure={STRUCTURE.sections} report={REPORT} qnotes={this.state.qnotes}
                                                                                         changeskin={(w) => this.changeskin(w)}
                                                                                         where={(w,l) => this.where(w,l)}
                                                                                         notes={(e) => this.notes(e)}   /></td>
        {this.state.qnotes ? <td className='dependencylink'><table><tbody><tr><td>Notes&nbsp;&nbsp;{/*<button onClick={() => this.savenotes() } style={{ width: '50px' }} >save</button>*/}</td></tr>
              <tr><td><div className="notes"><Notes ref={this.notesRef} start={DATA.notes[this.state.location]}/></div></td>
                      </tr></tbody></table></td> : <></>}
                 </tr></tbody></table></div>;
  }

  changeskin(which)
  {
    var all={STRUCTURE_CLASSIC: STRUCTURE_CLASSIC,
             STRUCTURE_ALUN: STRUCTURE_ALUN,
             STRUCTURE: STRUCTURE,
             LISTSECT: LISTSECT,
             SECTIONCOUNT: SECTIONCOUNT,
             SIXXCS: SIXXCS,
             STARTDATA: STARTDATA,
             DATA: DATA};

    str.setskin(which,all); m_uitype=which;

    var newstate = Object.assign(this.state);
    newstate.type=which;
    this.setState(newstate);
  }

  savenotes()
  {
    var text = this.notesRef.current.state.text;
    while ( text.search("<p><br></p>")>0 )
    {
      text = text.replace("<p><br></p>", "");
    }
    if ( typeof DATA.notes==='undefined' ) DATA.notes = {};
    DATA.notes[this.state.location] = text;
  }

  where(w,l)
  {
    if ( typeof l==='undefined' ) this.savenotes();
    var newstate = Object.assign(this.state);
    newstate.location=w;
    this.setState(newstate);
  }

  notes(e)
  {
    var newstate = Object.assign(this.state);
    newstate.qnotes=e.target.checked;
    this.setState(newstate);
  }

}

//
// Error - desplays deck errors/warnings & well and layer reports
//
class Error extends React.Component
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props);
  }

  render()
  {

    if ( !this.props.report.go )
    {
      return(
      <div id="localoutput" >
        {this.props.report.text.split("\n").map(function(item,index) {
          return (
            <span key={index}>
              {item}
              <br/>
            </span>
          )
        })}
       </div>);
    }
    else
    {

      var listerrors = []; var listwarnings = []; var listwells = []; var listlayers = [];

      if ( typeof this.props.report.errors!=='undefined'   ) listerrors   = this.props.report.errors.map((v,index)   => this.rendererror(v,index,'#cc0000') );
      if ( typeof this.props.report.warnings!=='undefined' ) listwarnings = this.props.report.warnings.map((v,index) => this.rendererror(v,index,'#ff9933') );
      if ( typeof this.props.report.wells!=='undefined'    ) listwells    = this.props.report.wells.map((v,index)    => this.renderwells(v,index) );
      if ( typeof this.props.report.layers!=='undefined'   ) listlayers   = this.props.report.layers.map((v,index)   => this.renderlayers(v,index) );


      return (<table><tbody><tr><td className="errorbox">
        <div >
          <div className="errorreport">
            <table><tbody><tr><td>
              {listerrors.length>0? <span style={{ color: '#cc0000' }}><b><u>{listerrors.length} Errors</u></b></span> :
                                     <span>No Errors</span>}
                </td></tr>
              {listerrors}
             </tbody></table>
          </div>&nbsp;
          <div className="errorreport">
             <table><tbody><tr><td>
              {listwarnings.length>0? <span style={{ color: '#ff9933' }}><b><u>{listwarnings.length} Warnings</u></b></span> :
                                     <span>No Warnings</span>}
              </td></tr>
              {listwarnings}
             </tbody></table>
          </div>
        </div></td><td className="errorbox">

        <div className='summary'>
             <table><tbody><tr><td className="errorbox"><u>Well Summary</u></td></tr>
                <tr><td><div className='sumtable'><table><thead><tr><th>Well</th><th>Frac</th><th>Stages</th><th>Timing</th><th>Fluid</th><th>Proppant</th></tr></thead><tbody>
                 {listwells}
                </tbody></table></div></td></tr>
             </tbody></table>
          </div>&nbsp;
         <div className='summary'>
             <table><tbody><tr><td><u>Layering Summary</u></td></tr>
              <tr><td><div className='sumtable'><table><thead><tr><th>Layer</th><th>Rock</th><th>Thickness</th><th>Poro/Perm</th><th>Strength</th><th>Scal</th>{m_compopt?<th>Nporo</th>:<></> }</tr></thead><tbody>
                 {listlayers}
                </tbody></table></div></td></tr>
             </tbody></table>
          </div>
      </td></tr></tbody></table>
        );
    }
  }

  rendererror(v,index,col)
  {
    return (<tr key={index}><td><span style={{ color: col }}>{v}</span></td></tr>);
  }
  renderwells(v,index)
  {
    return (<tr key={index}><td>{v.well}</td><td>{v.frac}</td><td>{v.stages}</td><td>{v.sched}({v.time})</td><td>{v.injf}</td><td>{v.prop}</td></tr>);
  }
  renderlayers(v,index)
  {
    if ( m_compopt ) return (<tr key={index}><td>{v.layer}</td><td>{v.rock}</td><td>{v.dz}</td><td>{v.basic}</td><td>{v.geomech}</td><td>{v.scal}</td><td>{v.nporo}</td></tr>);

    return (<tr key={index}><td>{v.layer}</td><td>{v.rock}</td><td>{v.dz}</td><td>{v.basic}</td><td>{v.geomech}</td><td>{v.scal}</td></tr>);
  }
}

//
// Wgplot - 3D plot of well and geology
//
class Wgplot extends React.Component
{
  // eslint-disable-next-line
  constructor(props)
  {
    super(props);
  }

  render()
  {
    var wg = new Wellgeo(m_compopt,STARTDATA.constants);

    var  wellsect = this.getsection(DATA,'well');
    var layersect = this.getsection(DATA,'layer');

    var pwells = [];
    if ( typeof wellsect.well!=='undefined' )
    {
      for ( var i=0; i<wellsect.well.length; i++ )
      {
        if ( wellsect.well[i].type==='simple' )
        {
          var schedsect = this.getsection(DATA,'schedule');
          var fracsect  = this.getsection(DATA,'frac');
          pwells.push(wg.makesimplewell(wellsect.well[i],schedsect,fracsect));
        }
        else
        {
          pwells.push(wellsect.well[i]);
        }
      }
    }

    var extent = 0;
    var formsect  = this.getsection(DATA,'formation');
    if ( typeof formsect.formation!=='undefined' ) extent = formsect.formation[0].para[5].value;

    var qcontacts = !(global.common.srv.go && this.props.qplot);

    var what = wg.plotwell(pwells,this.getsection(DATA,'layer').layer,
                           this.getsection(DATA,'formation').formation,this.getsection(DATA,'formation').dip,
                           this.props.qplot,extent,qcontacts);

    if ( global.common.srv.go && this.props.qplot ) what.push(global.common.srv.data);

    var geology = wg.plotgeology(layersect.layer,this.getname(DATA,'layer'));

    return(
      <div id="plot" >
        <table><tbody><tr><td>
          { pwells.length>0 || (global.common.srv.go && this.props.qplot) ? <Plot
        data={what}
        layout={ {height: 500, width: 800} } /> : <></> }</td><td>
            { geology.length>0 ? <Plot
        data={geology}
        layout={ { barmode: 'stack',width: 250 } } /> : <></> } </td>
        </tr></tbody></table>
      </div>);
  }

  getsection(data,sixc)
  {
    var sect = SIXXCS[sixc].sect;
    var sel = 0;
    if ( typeof this.props.fileselected!=='undefined' && typeof this.props.fileselected[sect]!=='undefined' ) sel = this.props.fileselected[sect];
    return data[sect][sel].data;
  }

  getname(data,sixc)
  {
    var sect = SIXXCS[sixc].sect;
    var sel = 0;
    if ( typeof this.props.fileselected[sect]!=='undefined' ) sel = this.props.fileselected[sect];
    return data[sect][sel].name;
  }

}

////
//// Timeplot
////
//class Timeplot extends React.Component
//{
//  // eslint-disable-next-line
//  constructor(props)
//  {
//    super(props);
//  }

//  render()
//  {
//return (
//<div style={{ display: 'flex', maxWidth: 900 }}>
//  <Chart
//    width={400}
//    height={300}
//    chartType="Timeline"
//    loader={<div>Loading Chart</div>}
//    data={[
//      [
//        { type: 'string', id: 'Term' },
//        { type: 'string', id: 'Name' },
//        { type: 'date', id: 'Start' },
//        { type: 'date', id: 'End' },
//      ],
//      ['1', 'George Washington', new Date(1789, 3, 30), new Date(1797, 2, 4)],
//      ['2', 'John Adams', new Date(1797, 2, 4), new Date(1801, 2, 4)],
//      ['3', 'Thomas Jefferson', new Date(1801, 2, 4), new Date(1809, 2, 4)],
//    ]}

//  /> </div>  );

//  }
//}

//
// Outer handles LHS menu
//
class Outer extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state={ selected: 'models', showWelcome: false, showGettingstarted: false, showHelp: false,
                                     showDependency: false, showImport: false, showImportpvt: false,
                                     showprojects: false, projects: [], refwindow: null }
  }

  render()
  {
    var hiderun = global.common.hiderun;

    var models = <button onClick={() => this.models()} >Models</button>;
    var run    = <button onClick={() => this.run()}>Run</button>;
    var plot   = <button onClick={() => this.plot()}>Plot</button>;
    if ( this.state.selected==='models' ) models = <button onClick={() => this.models()} ><b>Models</b></button>;
    if ( this.state.selected==='run'    ) run    = <button onClick={() => this.run()}><b>Run</b></button>;
    if ( this.state.selected==='plot'   ) plot   = <button onClick={() => this.plot()}><b>Plot</b></button>;

    var colour='';
    var help='';
    var name='';
    if ( this.state.selected==='models' )
    {
      name='Models';
      colour='AntiqueWhite';
      help = <div><p>The models section allows input and modification of model parameters in the four sections:</p>
      <ul><li>Reservoirs: geology and properties &nbsp;&nbsp;<span className='adddel' onClick={() => this.import('pvt')} ><u>(importing pvt data)</u></span> </li>
          <li>Wells: wells &nbsp;&nbsp;<span className='adddel' onClick={() => this.import('well')} ><u>(importing well&frac data)</u></span></li>
          <li>FracJobs: fracs, pumping schedule and treatments &nbsp;&nbsp;</li>
          <li>Scenarios: timing of interventions and production etc.</li>
      </ul>
      <p>The minimal data required is to define a well and a layer, all other data will be defaulted for this initial data entry.</p>
      <p>The <i>build</i> section will check for consistency in the data and construct the simulation dataset. At this point the
         dataset can be exported as a 6X input file. Alternatively the case will be available to be run remotely via the <b>Run</b> section.</p>
      <p>Some data items refer to other named objects, these are highlighted with a <span className='object'>blue border</span>. A key data section
         is the <i>Scenarios/schedule</i> which links a well, frac and stages (pumping schedule). The full interdependence can be viewed <span onClick={() => this.dependency()} className='adddel'><u>here</u>.</span></p>
      <p>At any time during the data input/modification a parameter name can be clicked on and highlighted. This parameter will then
         be available in the <i>build/sensitivities</i> section allowing a sensitivity analysis case to be built and run.</p>
      </div>;
    }
    if ( this.state.selected==='run'    )
    {
      name='Run';
      colour='#ffb3b3';
      help = <div><p>The <b>Run</b> section controls the remote running of the simulation. A login is required prior to initiating the run.</p>
      <p>The status button will report the status of all recent runs. When the run has completed the summary plot information
         can be downloaded to the local machine but will also be directly available in the <b>Plot</b> section.</p>
      <p>The delete and delete all buttons remove the model and run results from the server. Any output that needs to be kept should be downloaded
         to the local disk prior to deletion.</p>
      </div>;
    }
    if ( this.state.selected==='plot'   )
    {
      name='Plot';
      colour='#F4F6F6';
      help = <div><p>The <b>Plot</b> section enables the results of the simulations to be plotted, typically as a function of time.</p>
      <p>Summary data can be loaded either from the local disk (add model) or from the server (get model). Any mnemonic can be plotted
         against any other, selected for well, cell etc. </p>
      </div>;
    }

    var manual    = m_server+"/HTML/6XManual.html";
    var rksjson   = m_server+"/HTML/Simulator/RKSJSON.html";
    var pvtschema = m_server+"/HTML/schema/pvt_schema.json";
    var utilities = m_server+"/build/index.html";

    var listprojects = this.state.projects.map((v,index) => this.renderprojects(v,index) );

    //
    // Potential reference to slides etc
    //
    var ref = <></>;
    //if ( this.props.sixxc==='geomech' ) ref = <><button className="welhelp" onClick={() => this.testlink(3)} >ref</button></>;
    //if ( this.props.sixxc==='scal'    ) ref = <><button className="welhelp" onClick={() => this.testlink(4)} >ref</button></>;

    return (
              <table><tbody><tr><td>
      <table><tbody><tr><td>
      <div className="outermenu" >
        <table><tbody>
        <tr>
        <td><button className="welhelp" onClick={() => this.welcome()}>welcome</button></td>
        <td></td>
                <td>{models}</td>
        </tr>
        <tr>
        <td><button className="welhelp" onClick={() => this.help()}>help</button></td>
        <td></td>
	   {hiderun?  <td>{plot}</td>  : <td>{run}</td> }
        </tr>
        <tr><td>{ref}</td><td></td>
           {hiderun? <td></td>  :    <td>{plot}</td> }
        </tr>  
	</tbody>
        </table>

      </div>

       <ReactModal isOpen={this.state.showWelcome} appElement={document.getElementById('root')} className="welcome"  >
        <div >
        <table><tbody>
        <tr>
          <td><h3>Welcome to the 6Xapp - 0.1.23</h3></td><td><span onClick={() => this.closeWelcome()} >&times;</span></td>
        </tr>
        <tr><td>
          6X is a flow and geomechanical simulator used to study hydraulically fractured wells.
          <p>&nbsp;</p>
          The 6Xapp provides a quick and easy way of building a dataset on the local machine,
          running the simulation in the cloud and displaying the results in the browser. In addition it
          provides a simple mechanism to perform a sensitivity study for any selected parameter.
          <p>&nbsp;</p>
                  Optionally a full 6X dataset can be exported providing access to the full range of <a className='adddel' href={manual} target="_blank" rel="noopener noreferrer">6X</a> functionality.
          </td></tr><tr><td>&nbsp;</td></tr>
                <tr><td><span onClick={() => this.gettingstarted()} className='adddel'><u>getting started</u></span></td></tr>
         </tbody></table>
        </div>
      </ReactModal>

      <ReactModal isOpen={this.state.showGettingstarted} appElement={document.getElementById('root')} className="gettingstarted"  >
        <div >
        <table><tbody>
        <tr>
        <td><h3>Getting started:</h3></td><td><span onClick={() => this.closegettingstarted()} >&times;</span></td>
        </tr>
        <tr><td>
        In the <b>Models</b> section either load a pre-existing 6x project file (*.6xproj) or define a project from scratch.
        <p>
        To define a project from scratch the following minimum needs to be entered:</p>
        <table><tbody><tr><td>&nbsp;&nbsp;</td><td>A well name </td><td>A frac with associated stages will be scheduled</td></tr>
        <tr><td>&nbsp;&nbsp;</td><td>One or more layers</td></tr>
        <tr><td>&nbsp;&nbsp;</td><td>All other data can be defaulted</td></tr></tbody></table>
        <p>
        With the data in place the <b>Models</b>/<i>build</i> section is used to check the data consistency and build a 6X dataset.
        </p><p>
        A built dataset can be simulated from the <b>Run</b> section - note, a login is required at this point.
        </p><p>
        When the simulation completes, the results can be viewed in the <b>Plot</b> section, loading data via the "<i>Get Models</i>" button.
        </p><p>
        The parameters associated with a potential sensitivity study can be saved by clicking on the name of a parameter at any point. A sensitivity
        study can by run by selecting one of these parameters in the <b>Models</b>/<i>build/sensitivities</i> section.
        </p>
        </td></tr></tbody></table>
        </div>
      </ReactModal>

      <ReactModal isOpen={this.state.showHelp} appElement={document.getElementById('root')} className="help" style={ { content: {background: colour} } } >
        <div>
        <table><tbody><tr><td>

        <table><tbody><tr>
        <td><table><tbody><tr><td><b>Help: </b></td><td><b>{name}</b> section</td></tr></tbody></table></td></tr>
        <tr><td>{help}</td></tr></tbody></table></td>

            <td valign='top'><table><tbody><tr><td><span onClick={() => this.gettingstarted()} className='adddel'><u>getting started</u></span></td>
            <td><span onClick={() => this.closeHelp()} >&times;</span></td></tr>
            <tr><td className='dependencylink'><span onClick={() => this.dependency()} className='adddel'><u>dependency graph</u></span></td></tr>
            { global.common.hiderun? <></> : <tr><td><a className='adddel' href={utilities} target="_blank" rel="noopener noreferrer">utilities</a></td></tr> }
            <tr><td><span onClick={() => this.projects()} className='adddel'><u>Example projects</u></span></td></tr>
                  </tbody></table></td></tr>

        </tbody></table>
        </div>
      </ReactModal>

      <ReactModal isOpen={this.state.showprojects} appElement={document.getElementById('root')} className="gettingstarted"  >
        <div >
        <table><tbody>
        <tr>
        <td><h3>Projects:</h3></td><td><span onClick={() => this.closeprojects()} >&times;</span></td>
        </tr>
        <tr><td>

        <div className='jobtable'><table>
          <thead><tr><th style={{width: '20px'}}>#</th><th>Project</th><th style={{width: '400px'}}>Comment</th></tr></thead><tbody>
          {listprojects}
        </tbody></table></div>

        </td></tr></tbody></table>
        </div>

      </ReactModal>

      <ReactModal isOpen={this.state.showDependency} appElement={document.getElementById('root')} className="dependency" >
      <table><tbody><tr><td><b>Help: Depencency Graph</b></td><td><span onClick={() => this.closeDependency()} >&times;</span></td></tr>
        <tr><td><div>
              <img src={dependency} alt='Depencency Graph'  />
        </div></td></tr>
      </tbody></table>
      </ReactModal>

      <ReactModal isOpen={this.state.showImport} appElement={document.getElementById('root')} className="help" style={ { content: {background: colour} } } >
        <div>
        <table><tbody>
        <tr>
        <td><table><tbody><tr><td><b>Help: </b> Importing realistic well paths and fracture descriptions</td></tr></tbody></table></td>
            <td><span onClick={() => this.closeImport('well')} >&times;</span></td>
        </tr>
        <tr><td>
          <p>Idealized wells can be described by a few simple parameters in the <i>Wells/well</i> section. If however a real world well has
             been drilled it is appropriate to use the correct trajectory and associated stage locations. </p>
          <p>A full well trajectory can be imported via the <i><u>imp</u></i> button into the 6Xapp using the 6X json-well format (see <a href={rksjson} target="_blank" rel="noopener noreferrer">RKSJSON</a> keyword). If completions
             are present in the imported json file, then a fracture is also created.       </p>

        </td>
        </tr></tbody></table>
        </div>
      </ReactModal>

      <ReactModal isOpen={this.state.showImportpvt} appElement={document.getElementById('root')} className="help" style={ { content: {background: colour} } } >
        <div>
        <table><tbody>
        <tr>
        <td><table><tbody><tr><td><b>Help: </b> Importing realistic pvt data</td></tr></tbody></table></td>
            <td><span onClick={() => this.closeImport('pvt')} >&times;</span></td>
        </tr>
        <tr><td>
          <p>A default light oil is available in the <i>Reservoir/fluid</i> section where only the initial bubble point can be varied. </p>
          <p>If the (black oil) PVT proerties are known these can be input via a json file consistent with
             this <a href={pvtschema} target="_blank" rel="noopener noreferrer">schema</a> via the <i><u>imp</u></i> button.</p>

        </td>
        </tr></tbody></table>
        </div>
      </ReactModal>

      </td></tr></tbody></table>
           </td></tr></tbody></table>
      );
  }

  testlink(slide)
  {
    if ( typeof this.refwindow!=='undefined' ) this.refwindow.close();
    var powerp = m_server+"/HTML/fracture_cartoon.pdf#page="+slide;
    this.refwindow = window.open(powerp, "_blank", "width=900,height=500");
  }

  welcome()
  {
    var newstate = Object.assign(this.state);
    newstate.showWelcome = true;
    this.setState(newstate);
  }

  closeWelcome()
  {
    var newstate = Object.assign(this.state);
    newstate.showWelcome = false;
    this.setState(newstate);
  }

  gettingstarted()
  {
    var newstate = Object.assign(this.state);
    newstate.showWelcome = false;
    newstate.showHelp = false;
    newstate.showGettingstarted =true;
    this.setState(newstate);
  }

  projects()
  {
    var file = m_server+'/projects/projects.json';

    var newstate = Object.assign(this.state);
    newstate.showWelcome = false;
    newstate.showHelp = false;
    newstate.showprojects =true;

    fetch(file)
    .then(res => res.text())
    .then( (result) => { this.parseproject(newstate,result); },
            (error) => { global.alertx(" projects error: "+error); }
          )
  }

  parseproject(newstate,result)
  {
    newstate.projects = JSON.parse(result);
    this.setState(newstate);
  }

  closeprojects()
  {
    var newstate = Object.assign(this.state);
    newstate.showprojects =false;
    this.setState(newstate);
  }

  renderprojects(v,index)
  {
    return (<tr key={index}><td>{index}</td>
               <td><span className='adddel' onClick={() => this.getproject(v.name)} >{v.name} </span></td>
               <td>{v.comment}</td></tr>);
  }

  getproject(name)
  {
    var file = m_server+'/projects/'+name+'.6xproj';

    fetch(file)
    .then(res => res.text())
    .then( (result) => { this.saveproject(name,result);},
            (error) => { global.alertx(" getproject error: "+error); }
          )
  }

  saveproject(name,data)
  {
    global.SaveAsFile(data,name+'.6xproj');
    global.alertx('6x example downloaded: '+name+'.6xproj',false);
  }

  dependency()
  {
    var newstate = Object.assign(this.state);
    newstate.showHelp = false;
    newstate.showDependency =true;
    this.setState(newstate);
  }

  import(what)
  {
    var newstate = Object.assign(this.state);
    newstate.showHelp = false;
    if ( what==='pvt' ) newstate.showImportpvt = true;
    else                newstate.showImport    = true;
    this.setState(newstate);
  }

  closeImport(what)
  {
    var newstate = Object.assign(this.state);
    newstate.showHelp = true;
    if ( what==='pvt' ) newstate.showImportpvt = false;
    else                newstate.showImport    = false;
    this.setState(newstate);
  }

  closeDependency()
  {
    var newstate = Object.assign(this.state);
    newstate.showHelp = true;
    newstate.showDependency =false;
    this.setState(newstate);
  }

  closegettingstarted()
  {
    var newstate = Object.assign(this.state);
    newstate.showGettingstarted = false;
    this.setState(newstate);
  }

  help()
  {
    var newstate = Object.assign(this.state);
    newstate.showHelp = true;
    this.setState(newstate);
  }

  closeHelp()
  {
    var newstate = Object.assign(this.state);
    newstate.showHelp = false;
    this.setState(newstate);
  }

  models()
  {
    var newstate = Object.assign(this.state);
    newstate.selected = 'models';
    this.setState(newstate);
    this.props.what(newstate.selected);
  }

  run()
  {
    var newstate = Object.assign(this.state);
    newstate.selected = 'run';
    this.setState(newstate);
    this.props.what(newstate.selected);
  }

  plot()
  {
    var newstate = Object.assign(this.state);
    newstate.selected = 'plot';
    this.setState(newstate);
    this.props.what(newstate.selected);
  }
}

//
// Runsreen - as it says: Runmain
//                        Getfile/Managerun
//
class Runscreen extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state={ mselected: [0], buildsel: -1, runname: 'default', instance: 0,
                 loginmessage:'not logged in', logmsg: 'loginmessage', usertype: 'full', runningon: '' }
    this.cpu=60;
    this.inputRef = React.createRef();
  }

  render()
  {
    const files = this.props.rundata.map((v,index) => this.renderfiles(v,index) );

    var buildsel = this.state.buildsel;
    if ( buildsel<0 )
    {
      buildsel = 0;
      if ( typeof this.props.buildfile!=='undefined' ) buildsel = this.props.buildfile;
    }

    return (
      <div style={{ background: this.props.structure.colour }} className='section' >
      <table><tbody><tr><td>
        <table><tbody>
        <tr><td><global.Header title={this.props.structure.title} fileselected={this.props.fileselected} /></td></tr>
            <tr><td><global.File files={files} selected={this.state.selected} multiple={this.state.mselected} onChange={(e) => this.handleFileChange(e) } /></td>
            <td>
                <Runmain files={this.props.build} selected={buildsel} name={this.state.runname}
                                login={this.state.loginmessage} logmsg={this.state.logmsg} awsstatus={this.props.awsstatus}
                                status={() => this.status()}
                                colour={this.props.structure.colour}
                                setaws={(a,b) => this.props.setaws(a,b)}
                                onChange={(e) => this.handleBuildChange(e)}
                                changeName={(e) => this.handleNameChange(e)}
                                loginmessage={(e,f) => this.loginmessage(e,f)}
                                setusertype={(t) => this.usertype(t)}  usertype={this.state.usertype}
                                setcpu={(e) => this.setcpu(e)}
                                queue={this.props.queue} setqueue={(e) => this.props.setqueue(e)}
                                queues={this.props.queues} setqueues={(r) => this.props.setqueues(r)} />
             </td></tr>
                </tbody></table>
        </td></tr><tr><td>

        <table><tbody>
          <tr><td><global.Getfile name={this.props.structure.thing} onClick={(i) => this.handleNewFile(i)} />
            <div className="hidden" > <input type={'file'} ref={this.inputRef} value={''}
                                                accept={this.props.structure.import}
                                                onChange={(e) => this.handleFileSelect(e)} ></input> </div></td>
                <td><Managerun root={this.props.build[buildsel].name} colour={this.props.structure.colour}
                  run={() => this.remoterun()}  status={() => this.status()} delete={(a) => this.delete(a)}
                  awsstatus={this.props.awsstatus} setaws={(a,b) => this.setaws(a,b)} usertype={this.state.usertype}
                  loginmessage={(e,f) => this.loginmessage(e,f)}
                  setqueues={(r) => this.props.setqueues(r)} /> </td></tr>
        </tbody></table>

          </td></tr></tbody></table>
      </div>
      );
  }

  renderfiles(v,index)
  {
    if ( typeof v.name==='undefined' ) return ('');
    else if ( v.name==='downloadall' ) return ('');
    else                               return ( v.name+' '+v.type);
  }

  handleFileChange(event)
  {
    var newstate = Object.assign(this.state);
    var options = event.target.options;
    newstate.mselected = [];
    for ( var i=0; i<options.length; i++)
    {
      if ( options[i].selected )
      {
        newstate.mselected.push(i);
      }
    }
    this.setState(newstate);
  }

  handleBuildChange(event)
  {
    var newstate = Object.assign(this.state);
    newstate.buildsel=event.target.selectedIndex;
    this.setState(newstate);
  }

  handleNameChange(event)
  {
    var newstate = Object.assign(this.state);
    newstate.runname=event.target.value;
    this.setState(newstate);
  }

  handleNewFile()
  {
    if ( m_user==='none' )
    {
      global.alertx('Login required before running');
      return;
    }
    this.inputRef.current.click();
  }

  handleFileSelect (evt)
  {
    var files = evt.target.files; // FileList object

    for ( var i=0; i<files.length; i++ )
    {
      var f = files[i];
      var name = f.name.substring(0,f.name.search("[.]"));
      var reader = new FileReader();

      reader.onload = this.onload(this,name);

      reader.onerror = function(event)
      {
        global.alertx("File could not be read",true);
      }

      reader.readAsText(f);
    }
  }

  onload(host,name)
  {
    return function(event)
    {
      var contents = event.target.result;
      var uname=name; // duplicates handled on the server

      fetch(m_remoteserver+'/dataupload',{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'withCredentials': true,
          'credentials': 'include',
          'sameSite': 'none'
        },
        body: JSON.stringify({
          dataname: uname,
          type: 'data',
          dataset: contents,
          devcmd: m_devcmd,
          awslambda: m_awslambda,
          cpulimit: this.cpu,
          queue: host.props.queue
        })
      })
      .then(res => res.json())
      .then( (result) => { host.chk(result);},
             (error) => { global.alertx(" error1 "+error); }
           )

      global.alertx(uname+' loaded & run',false);

    }
  }

  remoterun()
  {
    if ( m_user==='none' )
    {
      global.alertx('Login required before running');
      return;
    }

    var buildsel = this.state.buildsel;
    if ( buildsel<0 )
    {
      buildsel = 0;
      if ( typeof this.props.buildfile!=='undefined' ) buildsel = this.props.buildfile;
    }

    if ( buildsel>this.props.build.length )
    {
      global.alertx("Model has not been built, please build via Models/build");
      return;
    }

    var model = this.props.build[buildsel];

    if ( typeof model.buildrevs==='undefined' ||
         model.buildrevs===''                ||
        (model.data.single.length===0 && model.data.sensitivity.length===0) )
    {
      global.alertx("Model has not been built, please build via Models/build");
      return;
    }

    var runname = this.props.build[buildsel].name;
    if ( this.state.runname!=='default' && this.state.runname!=='' ) runname = this.state.runname;

    var data = DATA;

    var buildrevs = '';
    for ( var i=0; i<global.common.listsect.length; i++ )
    {
      if ( global.common.listsect[i]!=='build' )
      {
        buildrevs+=data[LISTSECT[i]][model[global.common.listsect[i]]].data.revision.rev.toString();
      }
    }

    if ( typeof model.dataset==='undefined' )
    {
      global.alertx("Model has not been built, please build via Models/build");
      return;
    }
    else if ( buildrevs!==model.buildrevs )
    {
      global.alertx("Model is not up to date, please rebuild via Models/build");
      return;
    }

    var uname=runname; // leave name duplication to the server

    var type = 'local';
    if ( this.props.awsstatus==='stop cloud' ) type = 'cloud';
    if ( model.mr                            ) type = 'mr';

    fetch(m_remoteserver+'/dataupload',{
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'withCredentials': true,
        'credentials': 'include',
        'sameSite': 'none'
      },
      body: JSON.stringify({
        dataname: uname,
        type: type,
        metadata: model.metadata,
        dataset: model.dataset,
        devcmd: m_devcmd,
        awslambda: m_awslambda,
        cpulimit: this.cpu,
        queue: this.props.queue
      })
    })
    .then(res => res.json())
    .then( (result) => { this.chkstatus(result); },
           (error) => { global.alertx(" error2 "+error); }
         )

  }

  chkstatus(result)
  {
    //this.status();  // Not currently checking status on a run submit
  }

  chk(result)
  {
  }

  jobs(result)
  {
    this.props.jobs(result);
  }

  getsection(data,sect,sel)
  {
    var ret = data[sect][sel].data;
    return ret;
  }

  response(result)
  {
  }

  status()
  {
    if ( m_user==='none' )
    {
      global.alertx('Login required');
      return;
    }

    var user = m_user;
    if ( m_remoteserver!==m_server ) user = 'dev@rks.com';

    if ( m_remoteserver!=='http://1.2.3.4')
    {
      fetch(m_remoteserver+'/'+user+'/jobs.json')
      .then(res => res.json())
      .then( (result) => { this.jobs(result);},
             (error) => { this.error(error); }
           )
    }
    else
    {
      var result = [{"name":"Testaws","meta":{"Reservoirs":{"name":"Res A_PF_SH","rev":161},"Wells":{"name":"Well Set A","rev":7},"FracJobs":{"name":"24St","rev":185},"Scenarios":{"name":"Ex2_24_30kbwpd","rev":13},"build":{"name":"EX3_SENS","rev":60}},"completed":true,"queued":false,"queue":1,"code":0,"type":"mr","day":16,"mon":1,"year":2022}];
      this.jobs(result)
    }
  }

  error(err)
  {
    global.alertx("job status is not currently available");
  }

  delete(qall)
  {
    if ( m_user==='none' )
    {
      global.alertx('Login required before deleting off the server');
      return;
    }

    var todelete = [];

    if ( qall ) todelete.push('*');
    else
    {
      for ( var i=0; i<this.state.mselected.length; i++ )
      {
        todelete.push(this.props.rundata[this.state.mselected[i]].name);
      }
    }

    fetch(m_remoteserver+'/delete',{
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'withCredentials': true,
        'credentials': 'include',
        'sameSite': 'none'
      },
      body: JSON.stringify({
        todelete: todelete
      })
    })
    .then(res => res.json())
    .then( (result) => { this.chk(result);},
           (error) => { global.alertx(" error3 "+error); }
         )

  }

  loginmessage(message,logmsg)
  {
    var newstate = Object.assign(this.state);
    newstate.loginmessage=message;
    newstate.logmsg=logmsg;
    this.setState(newstate);
  }

  usertype(type)
  {
    var newstate = Object.assign(this.state);
    newstate.usertype=type;
    this.setState(newstate);
  }

  setcpu(limit)
  {
    this.cpu=limit;
  }

  setaws(aws,runningon)
  {
    var newstate = Object.assign(this.state);
    newstate.runningon=runningon;
    this.setState(newstate);
    global.common.runningon=runningon;

    this.props.setaws(aws);
  }
}

class Runmain extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state={ loginstatus: 'out', lastuser: '', stopaws: false, cpu: 60, request: false }
  }
  render()
  {
    const selected = this.props.files[this.props.selected].name;
    const listopts=this.props.files.map((string) => <option key={string.name} value={string.name}>{string.name}</option> );
    var name = this.props.name;
    if ( name==='default' ) name = selected;

    var log = <table><tbody><tr><td><span className="login" align={'center'} onClick={() => this.loginout('in')}>login</span></td>
                <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td><span className="login" onClick={() => this.request(false)}>request account</span></td></tr>
                 <tr><td>&nbsp;</td></tr><tr><td>&nbsp;</td></tr><tr><td>&nbsp;</td></tr><tr><td>&nbsp;</td></tr></tbody></table>;
    if ( this.state.loginstatus==='progressing' ) log = <Login login={(ok,u,e,t) => this.login(ok,u,e,t)} />;
    if ( this.state.loginstatus==='in'          ) log = <table><tbody><tr><td><span className="login" onClick={() => this.loginout('out')}>logout</span></td></tr>
                 <tr><td>&nbsp;</td></tr><tr><td>&nbsp;</td></tr><tr><td>&nbsp;</td></tr><tr><td>&nbsp;</td></tr></tbody></table>;
    var queues = this.props.queues.length>1;
    const listqueues=this.props.queues.map((q) => <option key={q.name} value={q.name}>{q.name+'('+q.limit+')'}</option> );
    var squeue = '';
    if ( this.props.queues.length>0 ) squeue = this.props.queues[this.props.queue].name;

    var renderqueues = <td><div className="rundrop">
                 <select value={squeue} onChange={(e) => this.props.setqueue(e)} >
                   {listqueues}
                 </select></div></td>;
    if ( this.props.awsstatus!=='stop cloud' && this.props.usertype==='cloud' ) renderqueues = <td>Local running not available</td>;
    if ( !queues ) renderqueues = <td></td>;

    return (<>
      <table><tbody><tr><td>
        <table><tbody><tr><td> <span className={this.props.logmsg} >{this.props.login}</span></td></tr>
        <tr><td>&nbsp;</td></tr>
        <tr><td>
              <table><tbody>
                <tr><td>Model</td><td>Run name</td><td>Cpu limit (mins)</td>{ queues ? <td>Queue</td> : <td></td>}</tr>
                <tr><td><div className="rundrop">
                 <select value={selected} onChange={(e) => this.props.onChange(e)} >
                   {listopts}
                </select></div></td>
                <td><div className="rundrop"><input type={'text'} value={name} onChange={(e) => this.props.changeName(e)}  /></div></td>
                <td><div className="cpubox"><input type={'text'} value={this.state.cpu} onChange={(e) => this.modcpu(e)}  /></div></td>
               {renderqueues}
              </tr></tbody></table>
        </td></tr></tbody></table></td><td>&nbsp;&nbsp;&nbsp;&nbsp;</td><td>{log}</td></tr>
        </tbody></table>

      <ReactModal isOpen={this.state.stopaws} appElement={document.getElementById('root')}  className="Awsstop"  >
        <div style={{ background: this.props.colour }} >
            <table><tbody><tr>
              <td>Stop aws? - note all data on the server well be lost</td><td>&nbsp;</td>
              <td><button onClick={() => this.stopcloudlogout() } style={{ width: '80px' }} >stop</button></td>
              <td><span onClick={() => this.awscancel()}>&times;</span></td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            </tbody></table>
        </div>
      </ReactModal>
      <ReactModal isOpen={this.state.request} appElement={document.getElementById('root')}  className="request"  >
        <div style={{ background: this.props.colour }} >
            <table><tbody><tr><td>To request an account please send an email address and contact details to:</td>
              <td><span onClick={() => this.request(true)}>&times;</span></td></tr>
            <tr><td></td></tr>
            <tr><td>Garf Bowen email: gbowen@ridgewaykite.com </td></tr>
            </tbody></table>
        </div>
      </ReactModal></>
      );
  }

  componentDidMount()
  {
    fetch(m_server+'/getuser',{
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'withCredentials': true,
        'credentials': 'include',
        'sameSite': 'none'
      },
      body: JSON.stringify({
      })
    })
    .then(res => res.json())
    .then( (result) => { this.who(result);},
            (error) => { global.alertx(" error4 "+error); }
          )
  }

  who(r)
  {
    if ( r.who!=='none' )
    {
      this.props.loginmessage('Logged in as '+r.who+'('+r.type+' user)','loginmessage');
      var newstate = Object.assign(this.state);
      newstate.loginstatus ='in';
      m_user = r.who;
      global.common.user = m_user;
      this.props.setusertype(r.type);

      //
      // Do we have a cloud instance running
      //
      if ( m_remoteserver!==m_server || r.address!=='' )
      {
        if ( r.address!==''  ) m_remoteserver = 'http://'+r.address;
        if ( r.supplier!=='' ) global.common.runningon = r.supplier;
        global.common.server = m_remoteserver;
        global.common.user = 'dev@rks.com';
        this.props.setaws('stop cloud',global.common.runningon);
        this.props.loginmessage('running on '+global.common.runningon,'loginmessage');
      }
      this.setState(newstate);

      if ( m_remoteserver!=='http://1.2.3.4'  )
      {
        fetch(m_remoteserver+'/queues.json')
        .then(res => res.json())
        .then( (result) => { this.props.setqueues(result);},
               (error) => { this.error(error); }
             )
      }
      else
      {
        var result=[{ name: "gpu", limit: 1, ngpu: 1, running: 0, queue: [], freegpu: []},
                    { name: "cpu", limit: 2, ngpu: 0, running: 0, queue: [], freegpu: []}];
        this.props.setqueues(result);
        global.common.user = 'dev@rks.com';
        this.props.setaws('stop cloud',global.common.runningon);
        this.props.loginmessage('running on '+global.common.runningon,'loginmessage');
      }
    }

  }

  onChange(e)
  {
    var newstate = Object.assign(this.state);
    newstate.name = e.target.value;
    this.setState(newstate);
  }

  request(qend)
  {
    var newstate = Object.assign(this.state);
    newstate.request=!qend;
    this.setState(newstate);
  }

  loginout(w)
  {
    var newstate = Object.assign(this.state);
    if ( w==='in'  ) newstate.loginstatus='progressing';
    if ( w==='out' || w==='outforce' )
    {
      if ( typeof this.props.awsstatus!=='undefined' && this.props.awsstatus!=='cloud' && w!=='outforce' )
      {
        newstate.stopaws = true;
        this.setState(newstate);
      }
      else
      {
        this.props.loginmessage(this.state.lastuser+' logged out','loginmessage');
        this.props.setaws('cloud','');
        newstate.loginstatus='out';
        m_user='none';
        global.common.user = 'none';

        fetch(m_server+'/logout',{
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'withCredentials': true,
            'credentials': 'include',
            'sameSite': 'none'
          },
          body: JSON.stringify({
          })
        })
        .then(res => res.json())
        .then( (result) => { },
               (error) => { global.alertx(" error (stopping cloud) "+error); }
             )
      }
    }
    this.setState(newstate);
  }

  login(ok,user,err,type)
  {
    var newstate = Object.assign(this.state);
    if ( ok )
    {
      this.props.loginmessage('logged in as '+user+ '('+type+' user)','loginmessage');
      newstate.loginstatus='in';
      this.props.setusertype(type);
      m_user=user;
      global.common.user = user;

      fetch(m_remoteserver+'/queues.json')
      .then(res => res.json())
      .then( (result) => { this.props.setqueues(result);},
             (error) => { this.error(error); }
           )

      this.props.status();
    }
    else
    {
      this.props.loginmessage(user+' login failed: '+err,'loginerror');
      newstate.loginstatus='out';
      m_user='none';
      global.common.user = 'none';
    }
    newstate.lastuser = user;
    this.setState(newstate);
  }

  hello(r)
  {
    var t = JSON.stringify(r);
    global.alertx(" ok "+t);
  }
  error(r)
  {
    global.alertx(" error5 "+r);
  }

  stopcloudlogout()
  {
    if ( !m_testaws )
    {
      fetch(m_server+'/stopcloud',{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'withCredentials': true,
          'credentials': 'include',
          'sameSite': 'none'
        },
        body: JSON.stringify({
        })
      })
      .then(res => res.json())
      .then( (result) => { this.awsresponce(result); },
              (error) => { global.alertx(" error (stopping cloud, logout) "+error); }
            )
    }
    else
    {
      global.alertx(' test: stop cloud from logout ',false);
    }

    m_remoteserver = m_server;

    this.props.setaws('cloud','');
    this.loginout('outforce');

    var newstate = Object.assign(this.state);
    newstate.stopaws = false;
    this.setState(newstate);
  }

  awsresponce(result)
  {
    if ( result.status!=='SUCCESS' )  global.alertx(' cloud stop failure ');
  }

  awscancel()
  {
    var newstate = Object.assign(this.state);
    newstate.stopaws = false;
    this.setState(newstate);
  }

  modcpu(e)
  {
    var newstate = Object.assign(this.state);
    newstate.cpu = e.target.value;
    this.setState(newstate);
    this.props.setcpu(newstate.cpu);
  }

}

class Managerun extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state={ showModal: false, showaws: false, stopaws: false, instance: 0, supplier: 0, downloadall: false };
    this.instances = ['g4dn.xlarge']; //['g4dn.xlarge', 'p3.2xlarge'];
    this.suppliers = ['AWS'];
  }
  render()
  {
    var supp = this.suppliers[this.state.supplier];
    var inst = this.instances[this.state.instance];
    const listsuppy=this.suppliers.map((string) => <option key={string} value={string}>{string}</option> );
    const listinsts=this.instances.map((string) => <option key={string} value={string}>{string}</option> );

    var ban = this.props.awsstatus!=='stop cloud' && this.props.usertype==='cloud';

    return (
      <div className="runbuttons">
      <table><tbody><tr>
        <td><button onClick={() => this.run()               } >run</button></td>
        <td><button onClick={() => this.props.status()      } >status</button></td>
        <td><button onClick={() => this.props.delete(false) } >delete</button></td>
        <td><button onClick={() => this.props.delete(true)  } >delete all</button></td>
        <td><button onClick={() => this.aws()               } >{this.props.awsstatus}</button></td>
        <td><button onClick={() => this.downloadall()       } >download all</button></td>
      </tr></tbody></table>
      <ReactModal isOpen={this.state.showModal} appElement={document.getElementById('root')}  className="Modal"  >
        <div style={{ background: this.props.colour }} >
            <form>
          <table><tbody><tr><td>&nbsp;</td></tr>
         { ban?
            <><tr><td>As a cloud user you need to fire up a cloud instance (cloud button), wait for 2or3 minutes start-up.</td></tr>
              <tr><td>You will then have a dedicated GPU machine until you shut done the instance.</td></tr>
              <tr><td><button onClick={() => this.cancel() } >ok</button></td></tr></> :
            <><tr><td>Submit remote run {this.props.root} ?</td><td>&nbsp;</td>
                  <td><button onClick={() => this.go() } >submit</button></td>
                  <td><button onClick={() => this.cancel() } >cancel</button></td></tr></> }
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
         </tbody></table></form>
      </div>
      </ReactModal>
      <ReactModal isOpen={this.state.showaws} appElement={document.getElementById('root')}  className="Aws"  >
        <div style={{ background: this.props.colour }} >
            <form>
          <table><tbody><tr><td><b>Cloud</b></td><td><span onClick={() => this.awscancel('start')} >&times;</span></td></tr><tr>
              <td>Running on a cloud service provides a dedicated machine to execute your simulations
                  <p>It typically takes 2 to 3 minutes to initiate the service, once running the service is available
                    until it is terminated or you logoff</p>
                    <p>The cloud status can be checked using the 'check cloud' button.</p></td></tr>
                  </tbody></table><table><tbody>
                <tr><td>Supplier</td><td>
        <select value={supp} onChange={(e) => this.handleChange(e,'supplier') } >
          {listsuppy}
        </select></td><td>Instance type</td><td>
        <select value={inst} onChange={(e) => this.handleChange(e,'instance') }>
          {listinsts}
        </select></td></tr><tr><td>&nbsp;</td></tr><tr>
                  <td><button onClick={() => this.awsgo() } style={{ width: '80px' }} >start</button></td>
                  <td><button onClick={() => this.awscancel('start') } >cancel</button></td></tr>
         </tbody></table></form>
      </div>
      </ReactModal>
      <ReactModal isOpen={this.state.stopaws} appElement={document.getElementById('root')}  className="Awsstop"  >
        <div style={{ background: this.props.colour }} >
            <table><tbody><tr>
              <td>Stop aws? - note all data on the server well be lost</td><td>&nbsp;</td>
              <td><button onClick={() => this.stopcloud() } style={{ width: '80px' }} >stop</button></td>
              <td><span onClick={() => this.awscancel('stop')}>&times;</span></td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            </tbody></table>
        </div>
      </ReactModal>
      <ReactModal isOpen={this.state.downloadall} appElement={document.getElementById('root')}  className="Awsstop"  >
        <div style={{ background: this.props.colour }} >
            <table><tbody><tr>
              <td>Download all, note this could be a large amount of data </td><td>&nbsp;</td>
              <td><button onClick={() => this.cancelall() } style={{ width: '80px' }} >ok</button></td>
              <td><span onClick={() => this.cancelall()}>&times;</span></td></tr>
              <tr><td>Check for all.tar.gz on the status page, which will be visable as a link when available to download</td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            </tbody></table>
        </div>
      </ReactModal>
      </div>
    );
  }

  run()
  {
    var newstate = Object.assign(this.state);
    newstate.showModal = true;
    this.setState(newstate);
  }

  go()
  {
    var newstate = Object.assign(this.state);
    newstate.showModal = false;
    this.setState(newstate);
    this.props.run();
  }

  cancel()
  {
    var newstate = Object.assign(this.state);
    newstate.showModal = false;
    this.setState(newstate);
  }

  aws()
  {
    if ( m_user==='none' )
    {
      global.alertx('Login required');
      return;
    }

    var newstate = Object.assign(this.state);
    if ( this.props.awsstatus==='stop cloud')
    {
      newstate.stopaws = true;
    }
    else if ( this.props.awsstatus==='check cloud' )
    {
      if ( !m_testaws )
      {
        fetch(m_server+'/checkcloud',{
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'withCredentials': true,
            'credentials': 'include',
            'sameSite': 'none'
          },
          body: JSON.stringify({
          })
        })
        .then(res => res.json())
        .then( (result) => { this.status(result); },
               (error) => { global.alertx(" check error "+error); }
             )
      }
      else
      {
        var result=[{ name: "gpu", limit: 1, ngpu: 1, running: 0, queue: [], freegpu: []},
                    { name: "cpu", limit: 2, ngpu: 0, running: 0, queue: [], freegpu: []}];
        this.props.setqueues(result);
        result={ status: 'running', address: '1.2.3.4' };
        this.status(result);
      }
    }
    else
    {
      newstate.showaws = true;
    }
    this.setState(newstate);
  }

  stopcloud()
  {
    this.props.setaws('cloud','');

    if ( !m_testaws )
    {
      fetch(m_server+'/stopcloud',{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'withCredentials': true,
          'credentials': 'include',
          'sameSite': 'none'
        },
        body: JSON.stringify({
        })
      })
      .then(res => res.json())
      .then( (result) => { this.awsresponce(result); },
              (error) => { global.alertx(" error (stopping cloud) "+error); }
            )
    }

    m_remoteserver = m_server;
    global.common.server = m_remoteserver;

    fetch(m_server+'/getuser',{
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'withCredentials': true,
        'credentials': 'include',
        'sameSite': 'none'
      },
      body: JSON.stringify({
      })
    })
    .then(res => res.json())
    .then( (result) => { this.whoonstop(result);},
            (error) => { global.alertx(" error9 "+error); }
          )

    fetch(m_remoteserver+'/queues.json')
    .then(res => res.json())
    .then( (result) => { this.props.setqueues(result);},
            (error) => { this.error(error); }
          )

    this.props.status();

    this.props.loginmessage(this.suppliers[this.state.supplier]+' shutdown','loginmessage');

    var newstate = Object.assign(this.state);
    newstate.stopaws = false;
    this.setState(newstate);
  }

  //
  // status - this is where the cloud instance is started
  //
  status(result)
  {
    if ( result.status!=='running' )
    {
      global.alertx(result.status);
    }
    else
    {
      global.alertx(' Cloud instance running \n   cloud:ip: '+result.address);
      m_remoteserver = 'http://'+result.address;

      var user = 'dev@rks.com';

      this.props.setaws('stop cloud',this.suppliers[this.state.supplier]);
      this.props.loginmessage('running on '+this.suppliers[this.state.supplier],'loginmessage');

      if ( m_remoteserver!=='http://1.2.3.4')
      {
        fetch(m_remoteserver+'/queues.json')
        .then(res => res.json())
        .then( (result) => { this.props.setqueues(result);},
                (error) => { global.alertx(" error getting cloud queues "+error); }
              )
      }

      global.common.server = m_remoteserver;
      global.common.user   = user;

      this.props.status(); // kill of previous status
    }
  }

  whoonstop(r)
  {
    if ( r.who!=='none' )
    {
      this.props.loginmessage('Logged in as '+r.who+'('+r.type+' user)','loginmessage');
      var newstate = Object.assign(this.state);
      newstate.loginstatus ='in';
      m_user = r.who;
      global.common.user = m_user;

      this.setState(newstate);
    }
  }

  awsgo()
  {
    if ( !m_testaws )
    {
      fetch(m_server+'/startcloud',{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'withCredentials': true,
          'credentials': 'include',
          'sameSite': 'none'
        },
        body: JSON.stringify({
          supplier: this.suppliers[this.state.supplier],
          instance: this.instances[this.state.instance]
        })
      })
      .then(res => res.json())
      .then( (result) => { this.awsresponce(result); },
             (error) => { global.alertx(" error6 "+error); }
           )
    }
    else
    {
      var result={ message: 'test cloud', status: 'SUCCESS' };
      this.awsresponce(result);
    }

    this.props.loginmessage('waiting on '+this.suppliers[this.state.supplier],'loginmessage');
    var newstate = Object.assign(this.state);
    newstate.showaws = false;
    this.props.setaws('check cloud',global.common.runningon);
    this.setState(newstate);
  }

  awsresponce(result)
  {
    if      ( result.status==='NOTCONFIGURED' )
    {
      global.alertx(' cloud not configured on the server');
      this.props.loginmessage(result.error,'loginerror');
      this.props.setaws('cloud','notcfg');
    }
    else if ( result.status==='TLIMIT' )
    {
      global.alertx(' cloud time exceeded ');
      this.props.loginmessage(result.error,'loginerror');
      this.props.setaws('cloud','texceed');
    }
    else if ( result.status!=='SUCCESS'       )
    {
      global.alertx(' cloud start failure ');
      this.props.loginmessage(result.error,'loginerror');
      this.props.setaws('cloud','fail');
    }
    if ( typeof result.message!=='undefined' ) global.alertx(result.message);
  }

  awscancel(what)
  {
    var newstate = Object.assign(this.state);
    if ( what==='start' ) newstate.showaws = false;
    if ( what==='stop'  ) newstate.stopaws = false;
    this.setState(newstate);
  }

  handleChange(event,what)
  {
    var newstate = Object.assign(this.state);
    if ( what==='supplier' ) newstate.supplier = event.target.selectedIndex
    if ( what==='instance' ) newstate.instance = event.target.selectedIndex
    this.setState(newstate);
  }

  downloadall()
  {
    fetch(m_remoteserver+'/downloadall',{
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'withCredentials': true,
        'credentials': 'include',
        'sameSite': 'none'
      },
      body: JSON.stringify({
      })
    })
    .then(res => res.json())
    .then( (result) => { this.downloadresponse(result);},
           (error) => { global.alertx(" error7 "+error); }
         )

  }

  downloadresponse(result)
  {
    var newstate = Object.assign(this.state);
    newstate.downloadall = true;
    this.setState(newstate);
  }

  cancelall()
  {
    var newstate = Object.assign(this.state);
    newstate.downloadall = false;
    this.setState(newstate);
  }

}

class Login extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state={ email: '', password: '' }
  }
  render()
  {
    return (
        <div className='loginpanel'>
          <table><tbody><tr><td><b>Login</b></td></tr>
          <tr><td>Email:</td><td><input type={'text'} name="username" value={this.state.email} onChange={(e) => this.onChange(e,'e')}  /></td></tr>
          <tr><td>Password:</td><td><input type={'password'} name="password" value={this.state.password} onChange={(e) => this.onChange(e,'p')}  /></td></tr>
           <tr><td><button onClick={() => this.login()   }>Login</button></td><td></td><td><span className="login" onClick={() => this.forget()  }>forgotten password</span></td></tr>
          </tbody></table>
        </div>
      );
  }

  onChange(e,w)
  {
    var newstate = Object.assign(this.state);
    if ( w==='e' ) newstate.email = e.target.value;
    if ( w==='p' ) newstate.password = e.target.value;
    this.setState(newstate);
  }

  login()
  {
    fetch(m_server+'/login',{
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'withCredentials': true,
        'credentials': 'include',
        'sameSite': 'none'
      },
      body: JSON.stringify({
        username: this.state.email,
        password: this.state.password
      })
    })
    .then(res => res.json())
    .then( (result) => { this.loginresponse(result);},
           (error) => { global.alertx(" error8 "+error); }
         )
  }

  loginresponse(response)
  {
    var ok = false;
    if ( response.status==='OK' ) ok = true;

    this.props.login(ok,this.state.email, response.error, response.type );
  }

  forget()
  {
    global.alertx('Sorry not implemented yet\nFor now start a new session with a different email, if neccesary RKS could recover your runs');
  }

}


class Notes extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state = { text: '' } // You can also pass a Quill Delta here
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(value)
  {
    this.setState({ text: value })
  }

  render()
  {
    return (
      <ReactQuill value={this.state.text}
                  defaultValue={this.props.start}
                  onChange={this.handleChange} />
    )
  }
}

//
// Set up the initial state/model
//
function initialdata()
{
  //
  // initial well
  //
  var sixxc = 'well';
  var newname = 'well1';
  var data = DATA['Wells'][0].data;

  var newpara=[];
  for ( var i=0; i<SIXXCS['well'].paras.length; i++ )
  {
    var defaultval = SIXXCS['well'].paras[i].value;
    newpara.push({ value: defaultval, sensitive: 0});
  }

  var newitem={ name: newname, type: 'simple', para: newpara };

  data[sixxc].push(newitem);

  //
  // Well special case (all very hardwired...)
  //
  if ( sixxc==='well' && data[sixxc].length===1 && !m_compopt )
  {
    var fracs  = SIXXCS['frac'].paras;
    var stages = SIXXCS['stages'].paras;
    var scheds = SIXXCS['schedule'].paras;
    var prods  = SIXXCS['production'].paras;

    // Frac --------------------------------------------------
    var frac = [];
    for ( var j=0; j<fracs.length; j++ )
    {
      frac.push({ value: SIXXCS['frac'].paras[j].value, sensitivity: false });
    }
    var newfrac={ name:'frac1', type: 'simple', para: frac };
    var nf = DATA[SIXXCS['frac'].sect].length-1
    DATA[SIXXCS['frac'].sect][nf].data['frac'].push(newfrac);

    // Stages ------------------------------------------------
    var stage = [];
    for ( j=0; j<stages.length; j++ )
    {
      stage.push({ value: SIXXCS['stages'].paras[j].value, sensitivity: false });
    }
    var newstage={ name:'stages1', type: 'simple', para: stage };
    nf = DATA[SIXXCS['stages'].sect].length-1
    DATA[SIXXCS['stages'].sect][nf].data['stages'].push(newstage);

    // Schedule -----------------------------------------------
    var sched = [];
    sched.push({ value: newname, sensitivity: false });
    for ( j=1; j<scheds.length; j++ )
    {
      sched.push({ value: SIXXCS['schedule'].paras[j].value, sensitivity: false });
    }

    var newsched={ name:'sched1', type: 'simple', para: sched };
    DATA[SIXXCS['schedule'].sect][nf].data['schedule'].push(newsched);

    // Injection Fluid ----------------------------------------
    var injf = [];
    injf.push({ value: SIXXCS['injfluid'].paras[0].value, sensitivity: false });
    injf.push({ value: 'none' , sensitivity: false });

    var newinjf={ name:'water', type: 'simple', para: injf };
    DATA[SIXXCS['injfluid'].sect][nf].data['injfluid'].push(newinjf);

    // Production -----------------------------------------------
    var prod = [];
    for ( j=0; j<prods.length; j++ )
    {
      prod.push({ value: SIXXCS['production'].paras[j].value, sensitivity: false });
    }

    var newprod={ name:'prod1', type: 'simple', para: prod };
    DATA[SIXXCS['production'].sect][nf].data['production'].push(newprod);
  }

  //
  // Initial layer
  //
  sixxc = 'layer';
  newname = 'one';
  data = DATA['Reservoirs'][0].data;

  newpara=[];
  for ( i=0; i<SIXXCS[sixxc].paras.length; i++ )
  {
    defaultval = SIXXCS[sixxc].paras[i].value;
    newpara.push({ value: defaultval, sensitive: 0});
  }

  newitem={ name: newname, type: 'simple', para: newpara };

  data[sixxc].push(newitem);

  cascadingdefaults(sixxc,data);
}


//
// Sort out dependencies
//
function cascadingdefaults(sixxc,data)
{
  //
  // local structure describing global properties
  //
  var paras = [];
  var where = [];
  var all = [];
  for ( var sect in STRUCTURE.sections )
  {
    for ( var isixc=0; isixc<STRUCTURE.sections[sect].sixcs.length; isixc++ )
    {
      all.push(STRUCTURE.sections[sect].sixcs[isixc]);
      for ( var ip=0; ip<STRUCTURE.sections[sect].sixcs[isixc].paras.length; ip++ )
      {
        var qcascade = STRUCTURE.sections[sect].sixcs[isixc].name===sixxc;
        paras.push(STRUCTURE.sections[sect].sixcs[isixc].paras[ip]);
        where.push({ sect: sect, sixc: STRUCTURE.sections[sect].sixcs[isixc].name, ip: ip, cascade: qcascade });
      }
    }
  }

  //
  // Cascading defaults
  //
  var nupdate=1;
  var alertmsg='';

  while ( true )
  {
    nupdate=0;

    for ( var i=0; i<paras.length; i++ )
    {
      var s = where[i].sect;
      var x = where[i].sixc;
      var p = where[i].ip;
      var nf = DATA[s].length-1
      var ns = DATA[s][nf].data[x].length-1

      var qc = where[i].cascade;

      if ( paras[i].comp!=='' && ns>=0 && qc )
      {
        var defaultsub=[];
        var name = DATA[s][nf].data[x][ns].para[p].value;

        for ( var k=0; k<all.length; k++ )
        {
          if ( all[k].name===paras[i].comp )
          {
            for ( var j=0; j<all[k].paras.length; j++ )
            {
              defaultsub.push({ value: all[k].paras[j].value, sensitivity: false });
            }
            break;
          }
        }

        var qdup=false;
        for ( sect in DATA )
        {
          if ( sect==='options' || sect==='version' || sect==='model' || sect==='notes' ) continue;

          var file=DATA[sect].length-1;

          if ( typeof DATA[sect][file].data[paras[i].comp]!=='undefined' )
          {
            for ( j=0; j<DATA[sect][file].data[paras[i].comp].length; j++ )
            {
              if ( DATA[sect][file].data[paras[i].comp][j].name===name )
              {
                qdup=true;
                break;
              }
            }

            // Don't repeat if we have another (A20)
            var len = DATA[sect][file].data[paras[i].comp].length;
            if ( len>0 )
            {
              data[x][data[x].length-1].para[p].value = DATA[sect][file].data[paras[i].comp][len-1].name;
              qdup = true;
            }

            if ( !qdup )
            {
              nupdate++;
              alertmsg += ' '+name;
              var newsubitem={ name: name, type: 'simple', para: defaultsub };
              DATA[sect][file].data[paras[i].comp].push(newsubitem);
              for ( j=0; j<where.length; j++ )
              {
                if ( paras[i].comp===where[j].sixc ) where[j].cascade = true;
              }
            }
          }
        }

      }
    }

    if ( nupdate===0 ) break;
  }

  return alertmsg;
}

//
// Define the program structure
//
var str = new Structure();

const STRUCTURE_CLASSIC=str.classic();
const STRUCTURE_ALUN=str.alun();

var STRUCTURE = STRUCTURE_ALUN;
var LISTSECT = [];
var SECTIONCOUNT={};

const SIXXCS=str.sixxcs();
const OTHERS=str.others();
const STARTDATA=str.startdata();

//
// main data store
//
var DATA={ version: m_svn, options: { units: m_unit, perfflow: m_perfflow, completions: m_compopt, ui: m_uitype, rkscomp: m_rkscomp } };

var all={STRUCTURE_CLASSIC: STRUCTURE_CLASSIC,
         STRUCTURE_ALUN: STRUCTURE_ALUN,
         STRUCTURE: STRUCTURE,
         LISTSECT: LISTSECT,
         SECTIONCOUNT: SECTIONCOUNT,
         SIXXCS: SIXXCS,
         STARTDATA: STARTDATA,
         DATA: DATA};

str.setskin('alun',all); m_uitype='alun';

convert(m_unit);

initialdata();

var REPORT={ go: false };

ReactDOM.render
(
  <Skin />,
  document.getElementById('root')
);









